export const common = {
emptyValue: "—",
a11y: {
goBack: "Volver",
loading: "Cargando",
removePhoto: "Quitar foto",
clearSelectedContact: "Quitar el contacto seleccionado",
selectNamed: "Seleccionar {{name}}",
removeStep: "Quitar paso",
removeFilter: "Quitar filtro",
previousMonth: "Mes anterior",
nextMonth: "Mes siguiente",
removeRelationship: "Quitar relación",
zoomIn: "Acercar",
zoomOut: "Alejar",
resetView: "Restablecer vista",
unlinkContact: "Desvincular contacto",
removeCharge: "Quitar cargo",
removeLineItem: "Quitar partida",
mapUnavailable: "Mapa no disponible en este dispositivo",
},
actions: {
  undo: "Deshacer",
cancel: "Cancelar",
keep: "Conservar",
search: "Buscar",
takePhoto: "Hacer foto",
chooseFromGallery: "Elegir de la galería",
chooseFile: "Elegir archivo",
dismiss: "Descartar",
tryAgain: "Intentar de nuevo",
saveChanges: "Guardar cambios",
saving: "Guardando…",
},
createVerbs: {
guide: "Guíame",
inspection: "Iniciar inspección",
job: "Registrar orden de trabajo",
report: "Informar de un problema",
asset: "Añadir activo",
site: "Añadir sitio",
contact: "Añadir contacto",
share: "Compartir activo",
template: "Crear lista de control",
recurringJobs: "Planes de mantenimiento",
document: "Añadir documento",
meterReading: "Registrar lectura",
maintenancePlan: "Añadir plan de mantenimiento",
knowledge: "Añadir conocimiento",
relationship: "Añadir relación",
assignAsset: "Asignar activo",
move: "Mover activo",
childSite: "Añadir sitio secundario",
conditionReport: "Informe del activo",
siteReport: "Site 360",
},
createNouns: {
  guide: "Guíame",
  asset: "Activo",
  inspection: "Inspección",
  job: "Orden de trabajo",
  report: "Reportar incidencia",
  maintenancePlan: "Mantenimiento",
  contact: "Contacto",
  site: "Sitio",
  template: "Lista de control",
},
actVerbs: {
  guide: "Guíame",
  inspection: "Inspeccionar",
  job: "Añadir orden de trabajo",
  report: "Avisar problema",
  share: "Compartir",
  document: "Añadir doc.",
  meterReading: "Añadir lectura",
  maintenancePlan: "Añadir plan",
  contact: "Añadir contacto",
  relationship: "Vincular activo",
  knowledge: "Añadir artículo",
  move: "Mover",
  conditionReport: "Informe del activo",
  asset: "Añadir activo",
  assignAsset: "Asignar",
  childSite: "Añadir subsitio",
  siteReport: "Site 360",
},
actVerbsA11y: {
  guide: "Guiarme en {{name}}",
  inspection: "Iniciar inspección de {{name}}",
  job: "Registrar orden de trabajo para {{name}}",
  report: "Informar de una incidencia en {{name}}",
  share: "Compartir {{name}}",
  document: "Añadir documento a {{name}}",
  meterReading: "Registrar lectura de {{name}}",
  maintenancePlan: "Crear plan de mantenimiento para {{name}}",
  contact: "Añadir contacto a {{name}}",
  relationship: "Añadir relación para {{name}}",
  knowledge: "Añadir conocimiento a {{name}}",
  move: "Mover {{name}}",
  conditionReport: "Generar el informe del activo {{name}}",
  asset: "Añadir activo a {{name}}",
  assignAsset: "Asignar activo a {{name}}",
  childSite: "Añadir sitio secundario bajo {{name}}",
  siteReport: "Informe Site 360 de {{name}}",
},
actionsMenuTitle: "Acciones",
actionGroups: {
  help: "Ayuda",
  work: "Trabajo",
  record: "Registrar",
  manage: "Gestionar",
  insight: "Análisis",
},
createFabA11y: "Crear — {{verbs}}",
capabilityLocked: {
tryPlanFree: "Probar {{plan}} gratis",
  thisFeature: "Esta función",
  notInCurrentPlan: "No incluida en tu plan {{plan}}",
  notInPlan: "No incluida en tu plan",
  includedFrom: "Incluida a partir del plan {{plan}}",
  includedHigher: "Incluida en un plan superior",
  internalEdition: "Este espacio de trabajo usa la edición interna Developer. Activa la función para Developer en Admin, Matrix.",
  noPlanIncludes: "No disponible en ningún plan por ahora",
  viewPlans: "Ver planes",
  openBilling: "Abrir Facturación y uso",
  viewPlansFor: "Ver los planes que incluyen {{feature}}",
  askOwner: "Pide al propietario de tu espacio de trabajo que mejore el plan.",
  managedOnWeb: "Disponible en el plan {{plan}} — elígelo en Facturación y uso.",
  managedOnWebUnnamed: "Los planes se eligen en Facturación y uso.",
  badge: "Mejora el plan para usarla",
  betaTitle: "{{name}} está en beta",
  betaDescription: "Únete al programa beta para probarla antes.",
  betaAction: "Solicitar acceso",
  adminTitle: "{{name}} está desactivada",
  adminDescription: "Está desactivada para este espacio de trabajo. Contacta con el soporte de AssetWRX para activarla.",
  dependencyTitle: "{{name}} necesita otra función",
  dependencyDescription: "Una función de la que depende está desactivada. Actívala primero.",
  unavailableTitle: "{{name}} no está disponible",
  unavailableDescription: "Esta función no está disponible para tu espacio de trabajo.",
},
kpi: {
  of: "de",
  partial: "parcial",
},
languageNames: {
  "ar": "العربية",
  "de-DE": "Deutsch (Deutschland)",
  "en-AU": "English (Australia)",
  "en-GB": "English (UK)",
  "en-US": "English (US)",
  "es-ES": "Español (España)",
  "fr-FR": "Français (France)",
},
createMenuTitle: "Crear",
detailActions: {
more: "Más",
moreActions: "Más acciones",
short: {
inspect: "Inspeccionar",
addJob: "Añadir orden de trabajo",
issue: "Notificar incidencia",
share: "Compartir",
document: "Doc.",
relate: "Relacionar",
contact: "Contacto",
insights: "Analítica",
},
sections: {
bringWorkIn: "Recibir trabajo",
doTheWork: "Hacer el trabajo",
records: "Registros",
aiAndGuidance: "IA y orientación",
},
},
alerts: {
errorTitle: "Error",
requiredTitle: "Obligatorio",
permissionRequiredTitle: "Permiso necesario",
signInRequiredTitle: "Inicio de sesión necesario",
},
labels: {
id: "ID",
allTypes: "Todos los tipos",
fileSelected: "Archivo seleccionado",
},
search: {
defaultPlaceholder: "Buscar",
clear: "Borrar búsqueda",
},
searchableList: {
searchPlaceholder: "Buscar…",
clearSearch: "Borrar búsqueda",
all: "Todos",
remove: "Quitar {{label}}",
clear: "Borrar",
noMatches: "Sin coincidencias.",
more_one: "{{count}} más — refine su búsqueda para verlo.",
more_other: "{{count}} más — refine su búsqueda para verlos.",
more_many: "{{count}} más — refine su búsqueda para verlos.",
},
counts: {
item_one: "{{count}} elemento",
item_other: "{{count}} elementos",
item_many: "{{count}} elementos",
mappedAssetsShowing_one: "Mostrando {{count}} activo en el mapa. Ocultos por no tener coordenadas: {{hidden}}.",
mappedAssetsShowing_many: "Mostrando {{count}} de activos en el mapa. Ocultos por no tener coordenadas: {{hidden}}.",
mappedAssetsShowing_other: "Mostrando {{count}} activos en el mapa. Ocultos por no tener coordenadas: {{hidden}}.",
itemsCaptureEvidence_one: "{{count}} elemento recoge actualmente al menos un tipo de evidencia.",
itemsCaptureEvidence_many: "{{count}} de elementos recogen actualmente al menos un tipo de evidencia.",
itemsCaptureEvidence_other: "{{count}} elementos recogen actualmente al menos un tipo de evidencia.",
importFileSummary: "{{file}} · {{rows}} · {{columns}}",
importRows_one: "{{count}} fila de datos",
importRows_many: "{{count}} de filas de datos",
importRows_other: "{{count}} filas de datos",
importColumns_one: "{{count}} columna",
importColumns_many: "{{count}} de columnas",
importColumns_other: "{{count}} columnas",
autoMapColumns_one: "Asignar automáticamente {{count}} columna por nombre",
autoMapColumns_many: "Asignar automáticamente {{count}} de columnas por nombre",
autoMapColumns_other: "Asignar automáticamente {{count}} columnas por nombre",
importPreviewRows_one: "Se muestra {{shown}} de {{count}} fila. Las filas válidas muestran los valores exactos que se importarán; las no válidas muestran los errores y los valores leídos de cada celda.",
importPreviewRows_many: "Se muestran las primeras {{shown}} de {{count}} filas. Las filas válidas muestran los valores exactos que se importarán; las no válidas muestran los errores y los valores leídos de cada celda.",
importPreviewRows_other: "Se muestran las primeras {{shown}} de {{count}} filas. Las filas válidas muestran los valores exactos que se importarán; las no válidas muestran los errores y los valores leídos de cada celda.",
applyRows_one: "Aplicar {{count}} fila",
applyRows_many: "Aplicar {{count}} de filas",
applyRows_other: "Aplicar {{count}} filas",
automationsReady_one: "{{count}} automatización lista",
automationsReady_many: "{{count}} de automatizaciones listas",
automationsReady_other: "{{count}} automatizaciones listas",
aiFollowUpsReady_one: "{{count}} seguimiento redactado por IA listo",
aiFollowUpsReady_many: "{{count}} de seguimientos redactados por IA listos",
aiFollowUpsReady_other: "{{count}} seguimientos redactados por IA listos",
extractedItemsFound_one: "Se encontró {{count}} partida. Edítala o desmárcala antes de añadirla a la orden de trabajo.",
extractedItemsFound_many: "Se encontraron {{count}} de partidas. Edítalas o desmárcalas antes de añadirlas a la orden de trabajo.",
extractedItemsFound_other: "Se encontraron {{count}} partidas. Edítalas o desmárcalas antes de añadirlas a la orden de trabajo.",
addItems_one: "Añadir {{count}} partida",
addItems_many: "Añadir {{count}} de partidas",
addItems_other: "Añadir {{count}} partidas",
},
teamMemberRole: {
owner: "Propietario",
admin: "Administrador",
member: "Miembro",
},
teamSummary: {
memberCount_one: "{{count}} miembro",
memberCount_many: "{{count}} miembros",
memberCount_other: "{{count}} miembros",
pendingInvites_one: "{{count}} invitación pendiente",
pendingInvites_many: "{{count}} invitaciones pendientes",
pendingInvites_other: "{{count}} invitaciones pendientes",
expiredInvites_one: "{{count}} invitación caducada",
expiredInvites_many: "{{count}} invitaciones caducadas",
expiredInvites_other: "{{count}} invitaciones caducadas",
twoFactorOn: "2FA activada",
twoFactorOff: "2FA desactivada",
youSuffix: "(usted)",
skillsLoading: "Habilidades: cargando…",
noSkills: "Sin habilidades registradas — toque para añadir",
skillCount_one: "{{count}} habilidad",
skillCount_many: "{{count}} habilidades",
skillCount_other: "{{count}} habilidades",
editSkillsA11y: "Editar las habilidades de {{name}}",
},
teamMemberAction: {
askAdmin: "Pedir que sea administrador",
changeToAdmin: "Cambiar a administrador",
changeToMember: "Cambiar a miembro",
requestSentTitle: "Solicitud enviada",
requestSentBody: "Se pedirá al propietario del equipo que apruebe a {{name}} como administrador.",
roleChangeFailed: "No se pudo cambiar el rol",
removeFailed: "No se pudo quitar al miembro",
decideFailed: "No se pudo guardar tu decisión",
pendingTitle: "Pendiente de tu aprobación",
pendingTitleAdmin: "Pendiente del propietario",
pendingRow: "¿Hacer administrador a {{name}}? Solicitado por {{requester}}.",
approve: "Aprobar",
decline: "Rechazar",
requestedPill: "Administrador solicitado",
},
embedNotice: {
  viewOnly: "Solo lectura: este portal te permite ver los registros, no cambiarlos.",
  loading: "Abriendo AssetWRX…",
  reload: "Recargar la página",
  expiredBody: "El inicio de sesión tardó más de lo que permite esta página. Recarga la página y entrarás directamente.",
  expiredTitle: "Recarga para continuar",
pageTitle: "Vista integrada",
unsupportedTitle: "No disponible aquí",
unsupportedBody: "Esta parte de AssetWRX no está incluida en esta vista integrada.",
goBack: "Volver",
openInAssetWrx: "Abrir en AssetWRX",
unavailableTitle: "La integración está desactivada",
unavailableBody: "AssetWRX integrado no está incluido en el plan de este espacio de trabajo. Pide al propietario de tu espacio de AssetWRX que cambie el plan.",
deniedTitle: "No se puede abrir esta vista",
deniedBody: "Este portal no puede abrir AssetWRX para usted aquí. Pida a su administrador de AssetWRX que revise la aplicación integrada.",
endedTitle: "Sesión finalizada",
endedBody: "Esta sesión integrada de AssetWRX ha finalizado. Recargue la página para iniciar una nueva.",
sessionRequiredTitle: "Ábralo desde su portal",
sessionRequiredBody: "Esta vista de AssetWRX solo puede mostrarla un portal aprobado. Ábrala desde allí.",
ssoDeniedTitle: "Use la cuenta de su organización",
ssoDeniedBody: "Este portal requiere que inicie sesión con la cuenta de Microsoft de su organización. Recargue la página para volver a intentarlo.",
},
tourStep: "Paso {{current}} de {{total}}",
guideFlow: {
  pages: {
    assets: "Activos",
    inspections: "Inspecciones",
    requests: "Solicitudes",
    jobs: "Órdenes de trabajo",
    reports: "Informes",
    contacts: "Contactos",
    contractors: "Contratistas",
  },
  ui: {
    open: "Abrir {{page}}",
    howItWorks: "Cómo funciona",
    comesInFrom: "Llega desde",
    feeds: "Alimenta {{stage}}",
    tapAgain: "Toque de nuevo para abrir.",
    subtitle: "El ciclo diario, de principio a fin. Pase el cursor o toque una etapa y abra su página.",
    stageA11y: "{{num}}. {{label}}. {{caption}}. Abre {{page}}.",
    inputA11y: "{{label}}. Alimenta {{stage}}. Abre {{page}}.",
  },
  "add-your-first-asset": {
    label: "Añadir activos",
    caption: "Registre lo que posee",
  },
  "run-an-inspection": {
    label: "Inspeccionar",
    caption: "Estado y evidencias",
  },
  "report-an-issue": {
    label: "Informar incidencias",
    caption: "Cualquiera puede avisar",
  },
  "create-a-job": {
    label: "Hacer el trabajo",
    caption: "Encargue y siga trabajos",
  },
  "share-a-report": {
    label: "Revisar y compartir",
    caption: "Cierre el ciclo",
  },
  "public-intake-qr": {
    label: "Avisos por QR público",
  },
  "share-for-requests": {
    label: "Solicitantes compartidos",
  },
  "add-a-contractor": {
    label: "Contratistas",
  },
},
notFound: {
stackTitle: "No encontrado",
title: "Página no encontrada",
goHome: "Ir al inicio",
body: "Es posible que el enlace esté desactualizado o que la página se haya movido.",
},
compact: {
  minutes: "{{n}} min",
  hours: "{{n}} h",
  days: "{{n}} d",
  now: "ahora",
  justNow: "ahora mismo",
  yesterday: "ayer",
  tomorrow: "Mañana",
},
relative: {
  today: "Hoy",
  tomorrow: "Mañana",
  daysAgo: "hace {{n}} d",
  yesterday: "Ayer",
  hoursAgo: "hace {{n}} h",
  minutesAgo: "hace {{n}} min",
  justNow: "Ahora mismo",
deadlinePassed: "Plazo vencido",
daysLeft_one: "Queda {{count}} día",
daysLeft_other: "Quedan {{count}} días",
hoursLeft_one: "Queda {{count}} hora",
hoursLeft_other: "Quedan {{count}} horas",
minutesLeft_one: "Queda {{count}} minuto",
minutesLeft_other: "Quedan {{count}} minutos",
daysLeft_many: "Quedan {{count}} días",
hoursLeft_many: "Quedan {{count}} horas",
minutesLeft_many: "Quedan {{count}} minutos",
},
errors: {
  unreachable: "No hemos podido comunicarnos con el servidor. Comprueba que estás en línea y vuelve a intentarlo.",
  notThrough: "No se ha podido completar. Inténtalo de nuevo.",
  workspaceUnavailable: "No hemos podido cargar tu espacio de trabajo. Comprueba que estás en línea y vuelve a intentarlo.",
  summaryAuthorOnly: "Solo la persona que realizó esta inspección, o un administrador del espacio de trabajo, puede cambiar su resumen, y solo hasta que se apruebe.",
  assetNotEditable: "No puedes cambiar uno de estos activos.",
  templateNotEditable: "No puedes cambiar con quién se comparte esta lista de control.",
  deleteApproved: "Una inspección aprobada no se puede eliminar: forma parte del registro de cumplimiento.",
  cancelApproved: "Una inspección aprobada no se puede cancelar.",
  requiredItemsIncomplete: "Cada elemento obligatorio necesita una respuesta o marcarse como omitido antes de completar esta inspección.",
  quoteRequestClosed: "Esta solicitud de presupuesto está cerrada. Se adjudicó, venció su plazo o se retiró.",
  postcheckRequired: "Hay que completar una verificación obligatoria antes de enviar esta orden de trabajo.",
  evidenceRequired: "Se necesita una foto o un vídeo del trabajo terminado. Añádalo a esta orden de trabajo o a una de sus subórdenes y vuelva a intentarlo.",
  precheckRequired: "Hay que completar una verificación previa antes de empezar esta orden de trabajo.",
  jobHandedOff: "Esta orden de trabajo se ha entregado a otra persona. Reasígnala o recupérala para cambiarla.",
  jobOutForQuotes: "Esta orden de trabajo está con contratistas para presupuestar. Elige un presupuesto o cierra la solicitud para cambiarla.",
  inspectionHandedOff: "Esta inspección se ha entregado a otra persona. Solo ella puede responderla.",
  retireOpenWork: "Este activo todavía tiene trabajo en curso. Complétalo o cancélalo antes de retirar el activo.",
  templateInUseBySchedules: "Esta lista de control aún se usa en inspecciones programadas próximas. Cancela primero esas programaciones.",
  approveOverseerOnly: "Solo el propietario, el aprobador o el equipo del activo pueden aprobar esta inspección, y el inspector no puede aprobar su propio trabajo.",
  waiverAdminOnly: "Solo un administrador del espacio de trabajo puede dispensar un hallazgo.",
  restoreAdminOnly: "Solo un administrador del espacio de trabajo puede restaurar un activo retirado.",
  retireOwnerOrAdmin: "Solo el propietario del activo o un administrador del espacio de trabajo puede retirarlo.",
  assetRetired: "Este activo se retiró y ya no admite nuevas inspecciones ni órdenes de trabajo.",
  workspaceReadOnly: "Este espacio de trabajo es de solo lectura. Elige un plan en Facturación para seguir añadiendo y editando.",
  assetPlanLimit: "Has alcanzado el límite de activos de tu plan. Un plan superior permite añadir más activos.",
  capabilityUnavailable: "Esta función no está incluida en tu plan. Elige un plan en Facturación para usarla.",
  assetSubscriptionRequired: "Tu espacio de trabajo ha usado los activos gratuitos de su plan. Inicia una suscripción para añadir más activos.",
  assetChanged: "Este activo cambió desde que lo abriste. Vuelve a cargarlo e inténtalo de nuevo.",
  onlineRequired: "Vuelve a conectarte para completar esta acción. La información introducida se conservará aquí.",
  jobUpdateRefused: "No se pudo actualizar esta orden de trabajo desde tu cuenta. Puede que se haya reasignado o cerrado. Actualiza e inténtalo de nuevo.",
  jobChanged: "Esta orden de trabajo cambió desde que la abriste. Vuelve a cargarla e inténtalo de nuevo.",
  sessionExpired: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
  alreadyExists: "Este elemento ya existe. Usa otro valor o actualiza el existente.",
  configMismatch: "La aplicación no pudo completar esta acción. Inténtalo de nuevo o contacta con soporte si sigue ocurriendo.",
  valueNotAllowed: "Uno de los valores no está permitido. Revisa lo que escribiste e inténtalo de nuevo.",
  network: "La conexión es lenta o no hay conexión. Inténtalo de nuevo.",
  requiredMissing: "Falta un campo obligatorio. Completa toda la información obligatoria.",
  noPermission: "No tienes permiso para hacer esto.",
  missingReference: "Se eliminó algo que esta acción necesita. Actualiza e inténtalo de nuevo.",
  notFound: "No se encontró este elemento. Puede que se haya eliminado.",
  fallback: "Algo salió mal. Inténtalo de nuevo.",
generic: "Algo salió mal.",
},
resilience: {
capability_disabled: {
title: "Esta función no está disponible",
body: "Tu organización no ha activado esta función. Contacta con un administrador si necesitas acceso.",
},
permission_denied: {
title: "No tienes permiso",
body: "Tu rol actual no permite realizar esta acción. El trabajo existente no se ha modificado.",
},
read_only: {
title: "Acceso de solo lectura",
body: "Puedes ver esta información, pero tu rol actual no permite modificarla.",
},
resource_unavailable: {
title: "Este elemento ya no está disponible",
body: "Puede que se haya eliminado o que tu acceso haya cambiado. Abre Actividad para continuar de forma segura.",
action: "Abrir actividad",
},
online_required: {
title: "Se necesita conexión",
body: "Vuelve a conectarte e inténtalo de nuevo. La información introducida permanecerá disponible en este dispositivo.",
},
},
sorting: {
sortBy: "Ordenar por",
newest: "Más reciente primero",
oldest: "Más antiguo primero",
last_updated: "Última actualización",
name_az: "Nombre A–Z",
name_za: "Nombre Z–A",
priority_high: "Prioridad alta → baja",
priority_low: "Prioridad baja → alta",
due_soonest: "Vence antes",
due_latest: "Vence después",
overdue_first: "Vencidos primero",
recently_active: "Actividad reciente",
status: "Estado",
condition_score: "Puntuación de condición",
health_score: "Puntuación de salud",
risk_score: "Puntuación de riesgo",
compliance_score: "Puntuación de cumplimiento",
last_inspection: "Última inspección",
completed_date: "Fecha de finalización",
assigned_to: "Asignado a",
scheduled_date: "Fecha programada",
inspection_score: "Puntuación de inspección",
requested_date: "Fecha de solicitud",
approval_status: "Estado de aprobación",
},
scanCapture: {
openSettings: "Abrir ajustes",
cameraBlockedMessage: "El acceso a la cámara está desactivado para AssetWRX. Actívalo en Ajustes o usa una foto.",
signInRequiredBody: "Inicia sesión para leer una foto con IA.",
aiOfflineStatus: "La lectura con IA estará disponible cuando vuelvas a estar en línea. Tu foto todavía está aquí.",
readingWithAiStatus: "Leyendo la foto con IA…",
couldNotReadPhotoTitle: "No se pudo leer la foto",
tryAgain: "Inténtelo de nuevo.",
noIdentifierReadable: "No se podía leer ningún VIN ni número de serie en esa foto. Inténtalo de nuevo o ingrésalo manualmente.",
permissionRequiredTitle: "Permiso necesario",
grantLibraryBody: "Conceda acceso a la biblioteca de fotografías.",
readingPhotoStatus: "Leyendo la foto…",
couldNotReadOnDeviceWeb: "Ingrese el valor a continuación o lea la foto con IA.",
couldNotReadOnDeviceNative: "No se pudo leer en este dispositivo. Ingrese el valor a continuación o lea la foto con IA.",
enterAValueTitle: "Introduzca un valor",
enterAValueBody: "Pegue o escriba un valor.",
readWithAiLabel: "Lee la foto con IA. Cuesta {{cost}}.",
readWithAiText: "Leer con IA ({{cost}})",
scanQrTitle: "Escanear código QR",
scanIdentifierTitle: "Escanear VIN / Serie",
webUnavailableMessage: "El escaneo de la cámara no está disponible en la web. Pegue un valor o elija una foto de la etiqueta para leerla.",
identifierInputLabel: "VIN o número de serie",
identifierPlaceholder: "Pegar o escribir VIN/serie…",
useThisValue: "Utilice este valor",
pickPhotoOfLabel: "Elige una foto de la etiqueta.",
requestingCameraPermission: "Solicitando permiso de cámara…",
cameraPermissionRequiredTitle: "Se necesita permiso de cámara",
cameraPermissionMessage: "Se necesita acceso a la cámara para escanear. También puedes leer una etiqueta de una foto guardada.",
grantPermission: "Conceder permiso",
usePhotoInstead: "Utilice una foto en su lugar",
closeScanner: "Cerrar escáner",
readingEllipsis: "Leyendo…",
positionQrHint: "Coloque el código QR en el marco.",
positionBarcodeHint: "Apunte al código de barras o toque el disparador para leer la etiqueta desde una foto",
takePhotoOfLabel: "Haz una foto de la etiqueta",
photo: "Foto",
library: "Biblioteca",
holdStill: "No te muevas…",
glareHint: "Hay reflejos en la placa: inclina un poco el teléfono o dale sombra a la placa y vuelve a intentarlo.",
darkHint: "Está demasiado oscuro para leer: enciende la luz o busca mejor iluminación y vuelve a intentarlo.",
},
cameraControls: {
noZoom: "1×",
zoomPercent: "{{percent}} %",
zoomOut: "Alejar",
zoomIn: "Acercar",
resetZoom: "Restablecer zoom",
zoomValueA11y: "Zoom al {{percent}} por ciento",
lightOn: "Encender la luz",
lightOff: "Apagar la luz",
},
cookieBanner: {
title: "Cookies en AssetWRX",
bodyBeforeLink: "Usamos cookies estrictamente necesarias para el funcionamiento de AssetWRX. Con tu consentimiento, también usaremos cookies para entender cómo se usa la aplicación y medir campañas de marketing. Puedes cambiar de opinión en cualquier momento en",
bodyCompact: "Solo cookies necesarias, salvo que permitas las de analítica y marketing. Detalles en la",
cookiePolicyLink: "Política de cookies",
rejectAll: "Rechazar todo",
managePreferences: "Administrar preferencias",
acceptAll: "Aceptar todo",
preferencesTitle: "Preferencias de cookies",
strictlyNecessaryTitle: "Estrictamente necesario",
alwaysOn: "Siempre encendido",
strictlyNecessaryBody: "Inicio de sesión, seguridad y funcionalidad principal.",
analyticsTitle: "Analítica",
analyticsBody: "Eventos de uso anónimos que nos ayudan a mejorar AssetWRX.",
marketingTitle: "Marketing",
marketingBody: "Mide el rendimiento de la campaña. Nunca vendemos tus datos.",
back: "Atrás",
savePreferences: "Guardar preferencias",
},
analyticsPrompt: {
title: "Ayúdanos a mejorar AssetWRX",
body: "Comparta datos de uso (las pantallas que usa y sus toques, nunca lo que escribe) para que podamos hacer la app más rápida y sencilla. Puede cambiarlo cuando quiera en Cuenta → Privacidad y datos → Preferencias de comunicación.",
allow: "Permitir",
notNow: "Ahora no",
},
webContactsList: {
sort: {
name_asc: "Nombre A–Z",
name_desc: "Nombre Z–A",
updated_desc: "Actualizado recientemente",
},
allRoles: "Todos",
filterByRoleA11y: "Filtrar contactos por rol",
roleA11y: "Rol: {{role}}",
moreFiltersA11y: "Más filtros: todos los tipos de roles y restablecer",
more: "Más…",
visibilityScopeA11y: "Alcance de visibilidad",
scopeAllA11y: "Alcance: todos",
scopeTeamA11y: "Alcance: equipo",
scopeAccountA11y: "Alcance: cuenta",
scopeAllLabel: "Todos los ámbitos",
scopeTeamLabel: "Equipo",
scopeAccountLabel: "Cuenta",
sortContactsA11y: "Ordenar contactos",
sortA11y: "Ordenar: {{sort}}",
importContactsA11y: "Importar contactos",
import: "Importar",
columns: {
name: "Nombre",
scope: "Ámbito",
roles: "Roles",
organisation: "Organización",
contact: "Correo electrónico / teléfono",
skills: "Competencias",
},
},
qrLabelPrint: {
defaultTitle: "Imprimir etiquetas QR",
noAssetsTitle: "Sin activos",
noAssetsBody: "Seleccione al menos un activo para imprimir etiquetas.",
noQrCodesTitle: "Sin códigos QR",
noQrCodesBody: "Los activos seleccionados aún no tienen códigos QR.",
labelsPrepared_one: "{{count}} etiqueta preparada.",
labelsPrepared_other: "{{count}} etiquetas preparadas.",
assetsSkipped_one: "{{count}} activo omitido (sin código QR).",
assetsSkipped_other: "{{count}} activos omitidos (sin código QR).",
labelsUsedFallback_one: "{{count}} etiqueta usó el código de AssetWRX (sin número de serie registrado).",
labelsUsedFallback_other: "{{count}} etiquetas usaron el código de AssetWRX (sin número de serie registrado).",
labelsReadyTitle: "Etiquetas listas",
printFailedTitle: "Error de impresión",
printFailedBody: "No se pueden generar etiquetas.",
selectedAssetsLabel: "Activos seleccionados",
selectedAssetsValue_one: "{{count}} seleccionado ({{withQr}} con código QR)",
selectedAssetsValue_many: "{{count}} seleccionados ({{withQr}} con código QR)",
selectedAssetsValue_other: "{{count}} seleccionados ({{withQr}} con código QR)",
templateLabel: "Lista de control",
qrContentsLabel: "Contenido del QR",
serialCoverageNote: "{{withSerial}} de {{total}} tienen número de serie; el resto usa el código de AssetWRX.",
scanActionLabel: "Acción de escaneo",
includeMetadataToggle: "Incluir metadatos cortos en etiquetas",
cancel: "Cancelar",
printLabels: "Imprimir etiquetas",
labelsPrepared_many: "{{count}} etiquetas preparadas.",
assetsSkipped_many: "{{count}} activos omitidos (sin código QR).",
labelsUsedFallback_many: "{{count}} etiquetas usaron el código de AssetWRX (sin número de serie registrado).",
},
reportReview: {
  stillToDecide_other: "{{count}} elementos aún necesitan una decisión. Lee los hallazgos de abajo y decide en Tus decisiones, más arriba.",
  stillToDecide_many: "{{count}} elementos aún necesitan una decisión. Lee los hallazgos de abajo y decide en Tus decisiones, más arriba.",
  stillToDecide_one: "{{count}} elemento aún necesita una decisión. Lee los hallazgos de abajo y decide en Tus decisiones, más arriba.",
  gate: {
    notYouBody: "Dinos qué relación tienes con este activo. El equipo que lo gestiona decide si puedes ver el informe.",
    notYouLink: "¿No eres la persona a la que se envió? Solicitar acceso",
    useDifferentAccount: "Usar otra cuenta",
    signedInAs: "Has iniciado sesión como {{email}}. Este informe se envió a otro correo.",
    notYouSignedOut: "¿No eres la persona a la que se envió? Inicia sesión y pulsa Solicitar acceso.",
    signedOutBody: "¿Te lo enviaron a ti? Inicia sesión con el correo al que se envió y se abrirá al momento.",
    requestAccess: "Solicitar acceso",
    sendFailedTitle: "No se pudo enviar la solicitud",
    roleManager: "Administrador o agente de la propiedad",
    outcomeClear: "Sin problemas",
    outcomeAttention: "Requiere atención",
    outcomeAction: "Requiere acción",
    askSender: "Pide a quien te lo envió que vuelva a enviar el enlace.",
  },
  jobs: {
    count_other: "{{count}} órdenes de trabajo",
    count_many: "{{count}} órdenes de trabajo",
    count_one: "{{count}} orden de trabajo",
    estimatedCost: "Estimado: {{amount}}",
    approvedCost: "Aprobado: {{amount}}",
    started: "Iniciada el {{date}}",
    scheduled: "Programada el {{date}}",
    assignedTo: "Asignada a {{name}}",
    cancelled: "Canceladas: {{n}}",
    inProgress: "En curso: {{n}}",
    completed: "Completadas: {{n}}",
  },
  done: {
    senderRepairs_other: "{{count}} reparaciones aprobadas. Pulsa Crear órdenes de trabajo en la inspección para programarlas.",
    senderRepairs_many: "{{count}} reparaciones aprobadas. Pulsa Crear órdenes de trabajo en la inspección para programarlas.",
    senderRepairs_one: "{{count}} reparación aprobada. Pulsa Crear órdenes de trabajo en la inspección para programarla.",
    repairsApproved_other: "Aprobaste {{count}} reparaciones. El equipo recibe el aviso y puede convertirlas en órdenes de trabajo.",
    repairsApproved_many: "Aprobaste {{count}} reparaciones. El equipo recibe el aviso y puede convertirlas en órdenes de trabajo.",
    repairsApproved_one: "Aprobaste {{count}} reparación. El equipo recibe el aviso y puede convertirla en una orden de trabajo.",
    allMarked: "Todos los elementos están marcados como aprobados. Rechaza los que no quieras y luego firma y pulsa Aprobar.",
    changesRequested: "Pediste cambios. {{company}} ya tiene tu nota.",
    allDeclined: "Aprobaste el informe y rechazaste todas las reparaciones. El equipo tiene tus notas.",
    approved: "Aprobaste este informe. El equipo ya está avisado.",
  },
  signOff: {
    decideFirst_other: "Decide primero cada elemento (quedan {{count}})",
    decideFirst_many: "Decide primero cada elemento (quedan {{count}})",
    decideFirst_one: "Decide primero cada elemento (queda {{count}})",
    sendBackPlaceholder: "¿Qué hay que cambiar? (obligatorio)",
    sendBack: "Devolver",
    promptDecideFirst: "Primero pulsa Aprobar o Rechazar en cada elemento de arriba. Puedes pulsar Devolver en cualquier momento.",
    promptReady: "Firma para dar conformidad. El equipo recibe el aviso y puede convertir las reparaciones aprobadas en órdenes de trabajo.",
    promptNoItems: "Lee el informe. Después firma para dar conformidad, o pulsa Devolver para pedir cambios.",
    sendToTeam: "Enviar al equipo",
    signatureLabel: "Firma aquí",
    recordsOnly: "Este informe es para tus registros.",
    changesMessage: "Pediste cambios",
    approvedMessage: "Lo aprobaste. Gracias.",
    changesPlaceholder: "¿Qué hay que rehacer?",
    requestChanges: "Pedir cambios",
    approve: "Dar conformidad",
    prompt: "Revisa el trabajo y apruébalo o pide cambios.",
    title: "Tu decisión",
  },
  insight: {
    itemsIncluded_other: "{{count}} elementos en este informe.",
    itemsIncluded_many: "{{count}} elementos en este informe.",
    itemsIncluded_one: "{{count}} elemento en este informe.",
    senderWaitingItems_other: "Esperando a que {{name}} decida {{count}} elementos.",
    senderWaitingItems_many: "Esperando a que {{name}} decida {{count}} elementos.",
    senderWaitingItems_one: "Esperando a que {{name}} decida {{count}} elemento.",
    toDecide_other: "{{count}} elementos necesitan tu decisión antes de aprobar.",
    toDecide_many: "{{count}} elementos necesitan tu decisión antes de aprobar.",
    toDecide_one: "{{count}} elemento necesita tu decisión antes de aprobar.",
    sourceLabel: "los elementos de este informe",
    actionSenderWait: "Quien lo envió recibe una notificación cuando respondan.",
    actionTrackJobs: "Sigue abajo las órdenes de trabajo creadas a partir de este informe.",
    actionApprove: "Firma y pulsa Aprobar. El equipo recibe el aviso al momento.",
    actionDecide: "Pulsa Aprobar o Rechazar en cada elemento.",
    metricNotDecided: "Sin decidir",
    metricToDecide: "Por decidir",
    checkFirst: "Revisa antes de decidir: {{list}}.",
    duplicates: "Posibles duplicados: {{n}}",
    noPhotos: "Sin fotos: {{n}}",
    urgent: "Urgentes: {{n}}",
    decisionCounts: "Aprobados: {{approved}} · Rechazados: {{declined}} · Sin decidir: {{pending}}",
    senderWaiting: "Esperando a que {{name}} apruebe el informe.",
    senderChangesNoReason: "{{name}} pidió cambios.",
    senderChanges: "{{name}} pidió cambios: «{{reason}}»",
    senderApprovedNoDate: "{{name}} lo aprobó.",
    senderApproved: "{{name}} lo aprobó el {{date}}.",
    nothingToDecide: "No hay nada que decidir. Lee el informe y pulsa Aprobar o Devolver.",
    youApproved: "Aprobaste este informe.",
    youApprovedOn: "Aprobaste este informe el {{date}}.",
    titleDone: "Revisión enviada",
    title: "Resumen de la revisión",
  },
  threadEmptySender: "Escribe a {{name}} aquí. Aún no hay mensajes.",
  threadEmptyReviewer: "Haz tus preguntas al inspector aquí. Aún no hay mensajes.",
  inspector: "Inspector",
  photoA11y: "Foto {{number}} de {{total}} de {{item}}",
  allDecided: "Todos los elementos están decididos. Firma y pulsa Aprobar.",
  decideAbove: "Elige en Tus decisiones, más arriba.",
  urgentFlagged: "Este elemento está marcado como urgente.",
  urgentNow: "Urgente: requiere atención ahora",
  recommendation: "Recomendación",
  description: "Descripción",
  ratingType: {
    condition: "Estado",
    level: "Nivel",
    passFlagFail: "Correcto, aviso o fallo",
    passFailNa: "Correcto, fallo o N/A",
    yesNo: "Sí o no",
  },
  theirDecisions: "Sus decisiones",
  reviewerFallback: "El revisor",
  theTeam: "El equipo",
  otherGroup: "Otros",
  helloGreeting: "Hola, {{name}} — {{greeting}}",
  startedOn: "Iniciada el {{date}}",
  completedOn: "Completada el {{date}}",
  inspectionFallback: "Inspección",
  openAssetA11y: "Abrir {{name}}",
  metaPill: "Revisión del informe",
  notYours: "Solo la persona a la que se envió este informe puede aprobarlo o devolverlo.",
  saveFailed: "No se pudo guardar tu elección. Comprueba tu conexión e inténtalo de nuevo.",
  evidenceFailed: "No se pudieron cargar los hallazgos y las fotos. Comprueba tu conexión e inténtalo de nuevo.",
  evidenceTimeout: "La inspección tarda demasiado en cargarse. Comprueba tu conexión e inténtalo de nuevo.",
},
jobReportShare: {
  assetFallback: "Activo",
  recipientFallback: "Destinatario",
  jobFallback: "Orden de trabajo",
  emailSubject: "Informe de finalización de la orden de trabajo – {{jobTitle}}",
headerTitle: "Informe de finalización de orden de trabajo",
shareLinkNotFound: "No se encontró el enlace compartido.",
goToAssetWrx: "Ir a AssetWRX",
signInToViewTitle: "Inicie sesión para ver este informe",
signInToViewBody: "Este informe de finalización de orden de trabajo se compartió con su dirección de correo electrónico. Inicie sesión (o cree una cuenta gratuita con ese correo electrónico) y el informe se abrirá automáticamente.",
signIn: "Iniciar sesión",
createAccount: "Crear cuenta",
noAccessOrNotFound: "No se encontró el enlace compartido o no tiene acceso. Si el informe se compartió con otra dirección de correo electrónico, inicie sesión con esa dirección para abrirlo.",
tryAgain: "Intentar de nuevo",
loadingReport: "Cargando informe…",
loadTimeout: "El informe tarda demasiado en cargarse. Comprueba tu conexión y vuelve a intentarlo.",
loadFailed: "No se pudo cargar este informe.",
},
qrScanFallback: {
linkToExistingAsset: "Vincular a un activo existente",
title: "Código QR no encontrado",
message: "El código QR escaneado \"{{value}}...\" no coincide con ningún activo existente.",
createNewAsset: "Crear nuevo activo",
createNewAssetSubtitle: "Cree un nuevo activo y vincule este código QR.",
orLinkToExisting: "O vincular a un activo existente",
chooseAssetPlaceholder: "Elegir un activo",
chooseAssetHint: "Elige el activo al que vincular este código QR",
linkQrCode: "Vincular código QR",
successTitle: "Correcto",
successBody: "QR vinculado al activo correctamente.",
errorTitle: "Error",
linkFailed: "No se pudo vincular el código QR.",
},
inboxSidebar: {
  openA11y: "Abrir {{title}}",
  openAction: "Abrir",
  snoozeFailed: "No se pudo posponer. Comprueba tu conexión e inténtalo de nuevo.",
  snoozedUntil: "Pospuesto hasta las {{time}}. Volverá entonces.",
groupLabel: {
high: "Requiere su atención",
medium: "Actualizaciones",
low: "Info",
read: "Leídas",
},
inboxA11y: "Notificaciones",
expandInbox: "Mostrar notificaciones",
myQueue: "Notificaciones",
collapseInbox: "Ocultar notificaciones",
allCaughtUp: "Todo al día",
noActionableNotifications: "No tienes notificaciones que requieran acción.",
itemsCountA11y_one: "{{title}}, {{count}} elemento",
itemsCountA11y_many: "{{title}}, {{count}} elementos",
itemsCountA11y_other: "{{title}}, {{count}} elementos",
snoozeA11y: "Posponer {{title}}",
markDoneA11y: "Marcar {{title}} hecho",
markAllRead: "Marcar todo como leído",
seeAllInMyQueue: "Ver todas las notificaciones",
seeAll: "Ver todos",
},
healthDetail: {
dismiss: "Descartar",
assetHealth: "Estado del activo",
close: "Cerrar",
subtitle: "El estado operativo es una puntuación de 0 a 100 a partir de documentos de cumplimiento, cronogramas y antigüedad de inspección, órdenes de trabajo abiertas, aprobaciones y resultados de inspección. Una calificación de condición de inspección de 1 a 5 se mide por separado.",
notScored: "Sin puntuar",
whatChangedScore: "¿Qué cambió tu puntuación?",
scoreHint: "Cada fila son los puntos eliminados de 100 antes de que la puntuación se limite entre 0 y 100.",
emptyScoreLine: "No se muestra ninguna puntuación porque no hay inspecciones completadas, órdenes de trabajo abiertas, inspecciones programadas, documentos de cumplimiento ni solicitudes abiertas para este activo.",
noPenaltiesLine: "No hay penalizaciones según las reglas actuales: la puntuación se mantiene en el máximo.",
flaggedItemsTitle: "Elementos marcados en el último informe",
openFindingA11y: "Abrir hallazgo: {{label}}",
positiveAdjustments: "Ajustes positivos",
recommendedActions: "Acciones recomendadas",
noActionsLine: "Sin acciones específicas: mantenga actualizadas las inspecciones y las órdenes de trabajo.",
goTo: "Ir a",
quickLinkJobs: "Órdenes de trabajo",
quickLinkInspections: "Inspecciones",
quickLinkStartInspection: "Iniciar inspección",
done: "Hecho",
},
contactInvite: {
invalidLink: "Enlace de invitación no válido",
invitationNotFound: "Invitación no encontrada",
invitationExpired: "Esta invitación ha caducado",
invitationInvalid: "Este enlace de invitación ya no es válido.",
failedToLoad: "No se pudo cargar la invitación",
loadTimeout: "La invitación tarda demasiado en cargarse. Comprueba tu conexión y vuelve a intentarlo.",
emailMismatchTitle: "El correo electrónico no coincide",
emailMismatchBody: "Esta invitación fue enviada a {{email}}. Por favor inicia sesión con ese correo electrónico para aceptar.",
errorTitle: "Error",
loadingInvitation: "Cargando invitación…",
invalidOrExpiredTitle: "No válido o caducado",
tryAgain: "Intentar de nuevo",
goBack: "Volver",
title: "Invitación de contacto",
descBeforeName: "Te han invitado a acceder a la aplicación como",
descAfterName: ". Esto vincula tu cuenta al contacto; no se te añadirá a ningún equipo.",
signInHint: "Inicia sesión para aceptar esta invitación",
signIn: "Iniciar sesión",
createAccount: "Crear cuenta",
signInWithDifferentEmailHint: "Esta invitación fue enviada a {{email}}. Inicia sesión con esa cuenta.",
signInWithDifferentAccount: "Iniciar sesión con otra cuenta",
accept: "Aceptar",
},
signatureField: {
defaultLabel: "Firma",
defaultHelperText: "Toque el cuadro para firmar; el pad se abre en pantalla completa.",
clearSignature: "Borrar firma",
clear: "Borrar",
signatureCapturedA11y: "Firma capturada: toque para cambiar",
signed: "Firmado",
tapToChange: "Toque para cambiar",
openSignaturePadA11y: "Abra el panel de firma para firmar",
tapToSignHere: "Toque para firmar aquí",
signHereTitle: "Firme aquí",
capturedSignatureA11y: "Firma capturada",
},
invoiceCapture: {
documentLabelPdf: "PDF",
documentLabelWord: "Word",
documentLabelGeneric: "Documento",
permissionRequiredTitle: "Permiso necesario",
grantCameraBody: "Conceda acceso a la cámara para tomar una foto.",
grantLibraryBody: "Conceda acceso a la biblioteca de fotografías.",
errorTitle: "Error",
couldNotOpenDocumentPicker: "No se pudo abrir el selector de documentos.",
uploadFailedTitle: "Error al cargar",
failedToUploadFile: "No se pudo cargar el archivo.",
actionSheetTakePhoto: "Hacer foto",
actionSheetChoosePhoto: "Elige foto",
actionSheetChooseFile: "Elija archivo (PDF, Word)",
addInvoiceTitle: "Añadir factura",
addInvoiceBody: "Elige foto o documento",
removeFileTitle: "Eliminar archivo",
removeFileBody: "¿Está seguro de que desea eliminar este archivo?",
remove: "Quitar",
removeInvoiceA11y: "Eliminar esta factura",
addInvoiceOrReceiptA11y: "Agregar factura o recibo",
},
complianceAuditDetail: {
dismiss: "Descartar",
title: "Cumplimiento y auditoría",
close: "Cerrar",
subtitle: "La puntuación refleja documentos, inspecciones, cronogramas, órdenes de trabajo y aprobaciones compartidas. Es una guía, no un consejo legal.",
whatsAffectingScore: "¿Qué está afectando tu puntuación?",
scoreHint: "Cada elemento muestra los puntos aplicados antes de que la puntuación tenga un límite entre 0 y 100.",
noScoredAdjustments: "Sin ajustes de puntuación: la puntuación está en el valor base (100 antes de aplicar los límites).",
findingsInLatestReport: "Hallazgos en el último informe",
openFindingA11y: "Abrir hallazgo: {{label}}",
positiveSignals: "Señales positivas",
recommendedActions: "Acciones recomendadas",
noActionsLine: "No hay acciones específicas: siga monitoreando cronogramas y documentos.",
automateTitle: "Crear automáticamente trabajo de renovación",
automateBody: "Cuando un certificado o documento esté a punto de caducar, genere la orden de trabajo de renovación e infórmeselo a la persona adecuada.",
goTo: "Ir a",
quickLinkDocuments: "Documentos",
quickLinkInspections: "Inspecciones",
quickLinkJobs: "Órdenes de trabajo",
done: "Hecho",
},
videoCapture: {
permissionRequiredTitle: "Permiso necesario",
permissionMessage: "Concede acceso a {{type}} para continuar.",
cameraAccessType: "la cámara",
photoLibraryAccessType: "la biblioteca de fotos",
videoTooLongTitle: "Vídeo demasiado largo",
videoTooLongBody: "Los vídeos deben durar {{max}} segundos o menos. Este vídeo dura {{actual}} segundos.",
couldNotAddVideoTitle: "No se pudo agregar el video",
failedToAddVideo: "No se pudo agregar el video. Comprueba tu conexión y vuelve a intentarlo.",
addVideoTitle: "Agregar vídeo",
chooseAnOption: "Elige una opción",
recordVideo: "Grabar vídeo",
chooseFromLibrary: "Elegir de la biblioteca",
videoLimitReachedTitle: "Límite de vídeo alcanzado",
videoLimitReachedBody_one: "Puede adjuntar hasta {{count}} vídeo aquí. Elimine uno para añadir otro.",
videoLimitReachedBody_other: "Puede adjuntar hasta {{count}} vídeos aquí. Elimine uno para añadir otro.",
removeVideoTitle: "Eliminar vídeo",
removeVideoBody: "¿Estás seguro de que deseas eliminar este vídeo?",
playVideoA11y: "Reproducir vídeo {{index}}",
videoPreviewA11y: "Vista previa del vídeo {{index}}",
videoLabel: "Vídeo {{index}}",
removeVideoA11y: "Eliminar vídeo {{index}}",
addVideoLabel: "Agregar vídeo",
videoLimitReachedBody_many: "Puede adjuntar hasta {{count}} vídeos aquí. Elimine uno para añadir otro.",
},
signatureCaptureModal: {
defaultHelperText: "Firme con el dedo o el mouse y luego toque Listo.",
cancelSigningA11y: "Cancelar firma",
saveSignatureA11y: "Guardar firma",
done: "Hecho",
},
conversationThread: {
defaultEmptyHint: "Aún no hay mensajes. Inicia la conversación.",
updates: "Actualizaciones",
updatesWithName: "Actualizaciones con {{name}}",
earlier: "Antes",
earlierA11y: "100 mensajes anteriores",
newer: "Más nuevo",
newerA11y: "100 mensajes más nuevos",
latest: "Último",
latestA11y: "Últimos mensajes",
loadingMessages: "Cargando mensajes…",
messagesUnavailable: "Los mensajes no están disponibles en este momento.",
noMessagesInThisPart: "No hay mensajes en esta parte de la conversación.",
startAnUpdatePlaceholder: "Escribe una actualización…",
messageA11y: "Mensaje",
sendMessageA11y: "Enviar mensaje",
couldNotSendMessage: "No se pudo enviar el mensaje.",
failedToSend: "No se pudo enviar",
},
guideArticle: {
userGuideTitle: "Guía del usuario",
helpTitle: "Ayuda",
articleNotFound: "Artículo no encontrado",
whyItMatters: "Por qué es importante",
showMe: "Muéstrame",
howToDoIt: "Cómo hacerlo",
whatToDoNext: "Qué hacer a continuación",
},
webQuickCreateMenu: {
quickCreateA11y: "Creación rápida",
quickCreate: "Creación rápida",
},
ownershipTransfer: {
aTeamMemberFallback: "un miembro del equipo",
couldNotUpdateTitle: "No se pudo actualizar la transferencia",
tryAgain: "Inténtelo de nuevo.",
doneTitle: "Hecho",
offerLapsesSuffix: " La oferta caduca el {{date}}.",
offeredOwnershipTitle: "Se le ha ofrecido la propiedad de {{teamName}}",
offeredOwnershipBody: "{{initiatorName}} quiere cederte el equipo. Como propietario, gestionas los miembros, la facturación y la configuración del espacio de trabajo; {{initiatorName2}} se convierte en administrador.",
acceptOwnership: "Aceptar propiedad",
nowOwnTeam: "Ahora eres propietario de {{teamName}}.",
decline: "Rechazar",
declinedOffer: "Rechazaste la oferta.",
waitingForAcceptTitle: "Esperando a que {{targetName}} acepte la propiedad",
waitingForAcceptBody: "Nada cambia hasta que acepten. Mientras tanto, sigues siendo el propietario.",
cancelOffer: "Cancelar oferta",
offerWithdrawn: "La oferta fue retirada.",
},
routeError: {
title: "Esta pantalla tuvo un problema.",
body: "El resto de la aplicación sigue funcionando y tu trabajo sin conexión en cola está a salvo. Inténtalo de nuevo o vuelve atrás y abre de nuevo esta pantalla.",
referenceLabel: "Referencia: {{referenceId}}",
tryAgain: "Intentar de nuevo",
goBack: "Volver",
},
photoAttachButton: {
couldNotAddPhotoTitle: "No se pudo agregar la foto",
pleaseTryAgain: "Inténtelo de nuevo.",
permissionRequiredTitle: "Permiso necesario",
permissionMessage: "Concede acceso a {{type}} para continuar.",
cameraAccessType: "la cámara",
photoLibraryAccessType: "la biblioteca de fotos",
addPhotoTitle: "Añadir foto",
addPhotoBody: "Agregue la foto tal como está o dibuje para resaltar las áreas primero.",
addNow: "Añadir ahora",
photoAdded: "Foto añadida",
drawToHighlight: "Dibujar para resaltar",
addPhotoOptionsTitle: "Agregar foto",
chooseAnOption: "Elige una opción",
camera: "Cámara",
photoLibrary: "Biblioteca de fotos",
attachPhotoA11y: "Adjuntar foto",
},
qrResolver: {
lookupTimedOut: "Se agotó el tiempo de espera de búsqueda de QR.",
resolvingQrCode: "Resolviendo el código QR...",
scannedAssetTitle: "Escaneaste un activo",
scannedAssetBody: "Este código pertenece a un activo gestionado en AssetWRX. Elige lo que te gustaría hacer.",
scannedAssetBodySignInOnly: "Este código pertenece a un activo gestionado en AssetWRX. Inicia sesión para verlo.",
reportAnIssue: "Informar un problema",
reportAnIssueA11y: "Informar un problema en este activo: no se necesita una cuenta",
signInToView: "Inicia sesión para ver",
signInToViewA11y: "Inicia sesión para ver este activo",
},
teamSwitcher: {
teamFallback: "Equipo",
personal: "Personal",
switchTeam: "Cambiar de equipo",
cancel: "Cancelar",
},
requiredSkillsPicker: {
defaultLabel: "Habilidades requeridas",
couldNotLoad: "No se pudieron cargar las habilidades en este momento.",
couldNotRefresh: "No se pudieron actualizar las habilidades. Intentar otra vez.",
requiredTitle: "Habilidades requeridas",
skillsTitle: "Competencias",
requiredHint: "Seleccione una o más habilidades. Se requiere al menos una.",
optionalHint: "Seleccione una o más habilidades de su catálogo (opcional).",
mustHaveTag: " · debe tener",
removeSkillA11y: "Quitar {{name}}",
changeRequiredSkills: "Cambiar las habilidades requeridas",
selectAtLeastOne: "Seleccione al menos una habilidad requerida",
addSkillsOptional: "Agregar habilidades (opcional)",
mandatoryHint: "Marque una habilidad como \"Debe tener\" y no se propondrá para este trabajo a nadie que no la tenga. Las demás solo hacen que quien las tenga aparezca más arriba.",
searchSkillsA11y: "Buscar habilidades",
searchSkillsPlaceholder: "Buscar habilidades...",
loadingSkills: "Cargando habilidades...",
noSkillsFound: "Aún no se han encontrado habilidades. Agregue habilidades en la configuración del contratista.",
noSkillsMatch: "Ninguna habilidad coincide con tu búsqueda.",
removeSkillRowA11y: "Quitar {{name}}",
addSkillRowA11y: "Agregar {{name}}",
mustHaveOnA11y: "{{name}} es imprescindible. En su lugar, conviértalo en una preferencia.",
mustHaveOffA11y: "Haga que {{name}} sea imprescindible para este trabajo",
mustHave: "Debe tener",
done: "Hecho",
},
reportingPage: {
executiveSummary: "Resumen ejecutivo",
supportingDetail: "Detalles de respaldo",
whatChanged: "Qué ha cambiado",
whyItMatters: "Por qué es importante",
action: "Acción",
hideReportStatements: "Ocultar declaraciones de informe",
showReportStatements: "Mostrar declaraciones de informe y filas de respaldo",
sourceLabel: "los registros de este informe",
},
refineSheet: {
defaultTitle: "Refinar",
activeFilters_one: "{{count}} filtro activo",
activeFilters_other: "{{count}} filtros activos",
noActiveFilters: "Sin filtros activos",
reset: "Restablecer",
doneA11y: "Hecho",
done: "Hecho",
activeFilters_many: "{{count}} filtros activos",
},
qrCodeDisplay: {
noQrCode: "No hay código QR disponible",
copyErrorTitle: "Error",
copyErrorBody: "No se pudo copiar el enlace del código QR.",
shareMessageWithName: "Código QR del activo {{name}}: {{url}}",
shareMessageNoName: "Código QR del activo: {{url}}",
copied: "Copiado",
copyLink: "Copiar enlace",
share: "Compartir",
},
jobCard: {
urgencyLow: "Baja",
urgencyMedium: "Media",
urgencyHigh: "Alta",
urgencyCritical: "Crítica",
scheduledFallback: "Programado",
dueDate: "Vence el {{date}}",
createdToday: "Creado hoy",
createdDate: "Creado {{date}}",
rejectedFallback: "Rechazada",
rejectedWithReason: "Rechazado: {{reason}}",
unassigned: "Sin asignar",
newUpdate: "Nueva actualización",
updatedAt: "Actualizado {{when}}",
skillCount_one: "{{count}} habilidad",
skillCount_other: "{{count}} habilidades",
a11yJob: "Orden de trabajo: {{title}}",
a11yAsset: "Activo: {{name}}",
a11yStatus: "Estado: {{status}}",
a11yPriority: "Prioridad: {{priority}}",
a11yCategory: "Categoría: {{category}}",
a11yAssignee: "Responsable: {{name}}",
a11ySchedule: "Programación: {{when}}",
a11yActivity: "Actividad: {{activity}}",
a11yAttentionOverdue: "Atención: Vencido",
a11yAttentionUnscheduled: "Atención: No programado",
openAssetA11y: "Abrir activo {{name}}",
detailsFallback: "detalles",
noAsset: "Sin activo",
followOnPending: "Seguimiento pendiente",
overdue: "Vencido",
unscheduled: "Sin programar",
followOnPendingApproval: "Seguimiento · Pendiente de aprobación",
priorityColumnHint: "Prioridad",
assigneeColumnHint: "Responsable",
dueScheduleColumnHint: "Vencimiento / programación",
typeColumnHint: "Tipo",
skillCount_many: "{{count}} habilidades",
},
healthCard: {
assetHealth: "Estado del activo",
noInspectionsYet: "Aún no hay inspecciones",
viewOpenJobsInWork: "Ver órdenes de trabajo abiertas en Trabajo",
startInspectionInWork: "Iniciar inspección en Trabajo",
viewHealthBreakdown: "Ver desglose de salud",
lastInspected: "Última inspección {{date}}",
},
failedSyncRecovery: {
defaultTitle: "No se pudo sincronizar",
dismiss: "Descartar",
copyError: "Copiar error",
retrySync: "Reintentar sincronización",
},
conflictResolution: {
title: "Otra persona cambió esta inspección",
body: "Otra persona guardó esta inspección mientras algunas de tus respuestas esperaban para guardarse. Tus respuestas siguen en este dispositivo hasta que elijas.",
mergeAndSync: "Conservar mis respuestas",
useLatestFromServer: "Usar las suyas",
hint: "Usar las suyas borra de este dispositivo tus respuestas sin guardar.",
decideLater: "Decidir más tarde",
},
evidenceCapture: {
defaultDocumentSectionLabel: "Documentos",
media: "Multimedia",
addPhotoOrVideoA11y: "Añade una foto o un vídeo",
addPhotoA11y: "Añadir una foto",
addVideoA11y: "Añadir un vídeo",
noMediaAttached: "No hay medios adjuntos",
hintPhoto_one: "Hasta {{count}} foto",
hintPhoto_other: "Hasta {{count}} fotos",
hintVideoWithPrefix_one: "Hasta {{count}} vídeo",
hintVideoWithPrefix_other: "Hasta {{count}} vídeos",
hintVideoNoPrefix_one: "{{count}} vídeo",
hintVideoNoPrefix_other: "{{count}} vídeos",
hintVideoDurationSuffix: ", máximo {{seconds}} s",
addEvidence: "Añadir evidencia",
takeAPhoto: "Toma una foto",
chooseAPhoto: "Elige una foto",
recordAVideo: "Grabar un vídeo",
chooseAVideo: "Elige un vídeo",
hintPhoto_many: "Hasta {{count}} fotos",
hintVideoWithPrefix_many: "Hasta {{count}} vídeos",
hintVideoNoPrefix_many: "{{count}} vídeos",
},
localComplianceRead: {
clearRead: "Borrar lectura",
checkThis: "Revisar esto",
confirm: "Confirmar",
certificateNumber: "Número de certificado",
nextDue: "Próximo vencimiento",
result: "Resultado",
readingOnDevice: "Leyendo el documento en este dispositivo…",
useCertificateNumber: "Utilice el número de certificado {{value}}",
useNextDueDate: "Usar próxima fecha de vencimiento {{value}}",
title: "Leer de este documento",
dismissA11y: "Descartar la lectura del documento",
readOnDeviceNoCredits: "Leído en este dispositivo: no se usan créditos de IA.",
use: "Usar",
},
planPicker: {
trial: "Prueba gratis de {{days}} días, luego {{price}}",
adds: "Añade {{list}}",
  titleLimit: "Mejora tu plan para añadir más",
  titleChange: "Elige tu plan",
  titleUnlock: "Desbloquear {{feature}}",
  checkoutFailedTitle: "No se pudo iniciar el pago",
  introLimit: "Elige un plan para añadir más activos y desbloquear más funciones. El periodo gratuito que te quede se conserva.",
  introChange: "Tu plan determina qué funciones están disponibles. Los activos y los créditos de IA se facturan por separado.",
  loading: "Cargando planes…",
  unavailable: "No se pudieron cargar los planes. Inténtalo de nuevo más tarde.",
  notNow: "Ahora no",
  current: "Actual",
yourPlan: "Tu plan",
payFor: "Pagar {{name}}",
renew: "Renovar {{name}}",
  priceFree: "Gratis",
  priceTalkToUs: "Habla con nosotros",
  priceFromPerAsset: "Desde {{price}}/activo/mes",
  priceFeePlusAssets: "{{price}}/mes + por activo",
  priceFeeOnly: "{{price}}/mes",
  priceAnnualPlusAssets: "{{price}}/año + por activo",
  priceAnnualOnly: "{{price}}/año",
  continueWith: "Continuar con {{name}}",
  contactSales: "Contactar con ventas",
  managedOnWeb: "No se puede comprar en la app",
  otherPlans: "Otros planes",
  webOnly: "Los planes y los créditos se eligen en Facturación y uso.",
},
storePlans: {
  title: "Suscríbete en la app",
  loading: "Cargando planes…",
  unavailable: "Las suscripciones no están disponibles ahora. Inténtalo más tarde.",
  perMonth: "{{price}} al mes",
  perYear: "{{price}} al año",
  subscribe: "Suscribirse",
  working: "Procesando…",
  restore: "Restaurar compras",
  activating: "Activando tu plan…",
  pending: "Tu compra se ha completado. Tu plan se actualizará en un momento. Toca Actualizar en Facturación y uso.",
  manage: "Gestionar suscripción",
  billedElsewhere: "La suscripción de este espacio de trabajo se factura fuera de esta app.",
  termsIos: "El pago se carga en tu ID de Apple al confirmar. La suscripción se renueva automáticamente salvo que se cancele al menos 24 horas antes del final del periodo actual. Gestiónala o cancélala en los ajustes de tu cuenta del App Store.",
  termsAndroid: "El pago se carga en tu cuenta de Google al confirmar. La suscripción se renueva automáticamente salvo que se cancele antes del final del periodo actual. Gestiónala o cancélala en las suscripciones de Google Play.",
  termsOfUse: "Términos de uso",
  privacyPolicy: "Política de privacidad",
},
planLimit: {
subscriptionRequiredTitle: "Límite del plan alcanzado",
nextAssetNeedsPlan: "Has usado los activos gratuitos de tu plan. El siguiente necesita un plan de pago.",
assetsUsed: "{{used}} de {{limit}} activos de tu plan.",
checkoutUnavailableTitle: "La compra aún no está disponible aquí",
checkoutUnavailableBody: "No se pueden comprar planes desde esta versión. Contáctanos y lo configuramos por ti.",
memberBodyCreate: "Tu espacio de trabajo ha alcanzado el límite de activos de su plan. Un administrador debe elegir un plan antes de poder añadir otro activo activo.",
memberBodyImport: "Tu espacio de trabajo ha alcanzado el límite de activos de su plan. Un administrador debe elegir un plan antes de poder importar más activos.",
  title: "Límite del plan alcanzado",
  notNow: "Ahora no",
  seePlans: "Ver planes",
  perAsset: "Por activo",
  limit: "Límite de activos: {{count}}",
},
/** Field sync states (lib/fieldSync/contract.ts is the English contract; a test keeps en-US equal to it). */
fieldSync: {
local_draft: {
label: "Guardado localmente",
message: "Guardado en este dispositivo: se sincronizará automáticamente cuando vuelvas a estar en línea.",
},
pending_sync: {
label: "Sincronizando",
message: "Sincronizando tus cambios…",
},
synced: {
label: "Sincronizado",
message: "Todos los cambios sincronizados.",
},
failed_sync: {
label: "Requiere atención",
message: "No se pudo guardar ese cambio: tu trabajo está a salvo en este dispositivo. Toca para reintentar.",
messageWithDetail: "No se pudo guardar: {{detail}} Toca para reintentar.",
},
conflict_review: {
label: "Requiere atención",
message: "Otra persona actualizó esto: échale un vistazo antes de guardar.",
},
online_required: {
label: "Conexión necesaria",
message: "Vuelve a conectarte para completar esta acción. La información introducida se conservará aquí.",
},
},
editionPlanSection: {
contactSalesTitle: "Contactar con ventas",
contactSalesBody: "Envíe un correo electrónico a {{email}} para hablar sobre el plan {{plan}}.",
notSet: "Sin definir",
customPricing: "Precios personalizados",
noCharge: "Sin coste",
changePlan: "Cambiar plan",
chooseAPlan: "Elige un plan",
changeTitle: "¿Cambiar a {{name}}?",
changeBody: "Un plan mayor empieza ahora y la diferencia por el resto de este periodo de facturación se cobra hoy. Un plan menor, o Free, empieza en tu fecha de renovación; hasta entonces no cambia nada.",
scheduledTitle: "Cambio de plan programado",
scheduledBody: "Tu plan cambia a {{name}} el {{date}}. Hasta entonces conservas lo que tienes. Vuelve a elegir tu plan actual para cancelar el cambio.",
changeConfirm: "Cambiar",
changeCancel: "Ahora no",
billMonthly: "Mensual",
billYearly: "Anual",
billingTerm: "Facturación",
},
legalDoc: {
unknownDocument: "Documento desconocido.",
loadFailed: "Este documento no se pudo cargar. Inténtelo de nuevo en breve.",
versionLabel: "Versión {{version}}",
effectiveLabel: "En vigor desde {{date}}",
titleFallback: "Aviso legal",
loading: "Cargando…",
errorTitle: "Error",
documentNotFound: "Documento no encontrado.",
},
notificationRecovery: {
title: "Notificación",
safeRecovery: "Recuperación segura",
},
actionSheet: {
cancelA11y: "Cancelar",
cancel: "Cancelar",
},
actionPopover: {
closeCreateMenuA11y: "Cerrar menú de creación",
},
fieldModeToggle: {
fieldModeA11y: "Modo de campo",
fieldModeHint: "Aumenta el contraste y el tamaño de las zonas táctiles para uso en exteriores",
fieldMode: "Modo de campo",
},
appErrorBoundary: {
title: "Algo salió mal",
body: "AssetWRX capturó el error. Puede volver a intentar esta pantalla sin perder el trabajo sin conexión en cola.",
retry: "Reintentar",
},
profileAvatar: {
profileAvatarA11y: "Avatar de perfil",
profileInitialsA11y: "Iniciales del perfil",
},
nativeDateTimePicker: {
selectDate: "Seleccionar fecha",
selectTime: "Seleccionar hora",
cancelSelectionA11y: "Cancelar la selección de {{mode}}",
cancel: "Cancelar",
confirmA11y: "Confirmar {{mode}}",
done: "Hecho",
},
assetMapView: {
basemapStreets: "Calles",
basemapSatellite: "Satélite",
basemapTopographic: "Topográfico",
overlayClusters: "Agrupación de clústeres",
overlayHeatmap: "Mapa de calor de densidad",
overlaySelectionHighlight: "Resaltado de selección",
threeDCameraTilt: "Inclinación de cámara 3D",
threeDTerrainRelief: "Relieve del terreno en 3D",
hideMapOptionsA11y: "Ocultar opciones del mapa",
basemapA11y: "Mapa base: {{name}}",
mapOptionsA11y: "Opciones del mapa",
rendererUnavailable: "El renderizador del mapa no está disponible en este dispositivo.",
},
uiCopy: {
  checkAnswerNotSavedTitle: "No se pudo guardar esa respuesta",
  checkLoadFailed: "No se pudo cargar esta comprobación.",
  fieldAssist: {
    tryAgain: "Inténtelo de nuevo.",
    revert: "Revertir",
    discard: "Descartar",
    accept: "Aceptar",
    suggestedTitle: "Texto sugerido",
    dictate: "Dictar",
    stop: "Detener",
  },
markAllNotificationsAsRead_2777a0: "Marcar todas las notificaciones como leídas",
retrySearch_eed38a: "Reintentar búsqueda",
importAssetsFromSpreadsheet_319028: "Importar activos desde hoja de cálculo",
filterBySite_cf1cee: "Filtrar por sitio",
couldntLoadYourAssets_9878ab: "No se pudieron cargar sus activos",
yourAssetsAreStillThereCheckYour_f01439: "Tus activos siguen ahí. Comprueba tu conexión y vuelve a intentarlo.",
loadingRelationshipView_b7eaea: "Cargando vista de relaciones…",
noMappedAssetsYet_6f573a: "Aún no hay activos en el mapa.",
saveCoordinatesOnAnAssetToEnable_da096f: "Guarde las coordenadas de un activo para habilitar la vista del mapa.",
mapUnavailableRightNow_d6091e: "El mapa no está disponible en este momento.",
theAssetListStillWorksNormally_b8aeb7: "La lista de activos todavía funciona normalmente.",
loadingMap_8f267a: "Cargando mapa…",
assignSite_e1d79b: "Asignar sitio",
assignToSite_5f6e86: "Asignar al sitio",
contactInsight_51a9e3: "Análisis del contacto",
findContactsSkills_f8dc04: "Buscar contactos",
refineContactFilters_fa9072: "Refinar filtros de contacto",
importContactsFromAFileOrYour_210d87: "Importa contactos desde un archivo o tu dispositivo",
refineContacts_982f6f: "Refinar contactos",
opensFiltersToChangeWhichContactsAre_304ff8: "Abre filtros para cambiar qué contactos se muestran.",
chooseAContactToSeeSharedAssets_8202a6: "Elija un contacto para ver activos compartidos, solicitudes y trabajos relacionados sin salir de esta página.",
noContactDetailsOnFile_131e9d: "No hay datos de contacto registrados",
noLinkedSkills_16d322: "No hay habilidades vinculadas",
noOpenJobsForThisContact_4857c4: "No hay órdenes de trabajo abiertas para este contacto",
historyNotes_83ccc2: "Historial y notas",
couldntRefreshYourWorkShowingWhatWas_8e2372: "No se pudo actualizar tu trabajo: se muestra lo último que se cargó. Toca para reintentar.",
generateAdvancedReport_7e5def: "Generar informe avanzado",
buildsAFullReportUsingInspectionsJobs_bfa133: "Crea un informe completo utilizando inspecciones, órdenes de trabajo, documentos, datos de riesgo, historial de mantenimiento e investigación opcional en Internet.",
advancedReportInsight_a02085: "Información avanzada sobre informes",
noAdvancedReportGeneratedYet_59d1d4: "Aún no se ha generado ningún informe avanzado.",
fillInDetailsToSeeAPreview_84bd8b: "Complete los detalles para ver una vista previa aquí.",
assetNameRequired_06d7dc: "Nombre del activo (obligatorio)",
suggestedIdentity_36046f: "Identidad sugerida",
dismissIdentitySuggestion_f3e055: "Descartar sugerencia de identidad",
identifyTheAssetTypeFromThePhoto_d205fa: "Identifique el tipo de activo de la foto usando IA",
identifiedFromPhoto_c90812: "Identificado a partir de la foto",
applyTheIdentifiedAssetType_a066ab: "Aplicar el tipo de activo identificado",
applyType_00972d: "Aplicar tipo",
dismissPhotoIdentity_a1052e: "Descartar la identificación por foto",
inServiceToday_7a4392: "¿En servicio hoy?",
yesInUse_0e9408: "Sí, en uso",
notYet_8de95f: "Todavía no",
qRCodeWillBeLinkedAfterCreation_87a9e9: "El código QR se vinculará después de crear el activo",
matchMyNearestSite_4d4d97: "Usar mi sitio más cercano",
tapToAddYourFirstPhoto_7f8b7c: "Toca para añadir tu primera foto",
gallery_9c30a3: "Galería",
removeAllPhotos_6c3c73: "Eliminar todas las fotos",
iDSerialOptional_25584f: "ID / Serie (opcional)",
thisReferenceLinksIoTDevicesAndAPI_4f5ce4: "Esta referencia vincula los dispositivos IoT y los eventos API a este activo.",
scanIDOrSerial_956e65: "Escanear ID o serie",
readFromPhoto_ee811f: "Leer desde foto",
relationshipsOptional_df493d: "Relaciones (opcional)",
vehicleType_964438: "Tipo de vehículo",
fuelType_0e58d4: "Tipo de combustible",
usage_0bb186: "Uso",
propertyType_8ad7ea: "Tipo de propiedad",
occupancy_570235: "Ocupación",
equipmentType_d92829: "Tipo de equipo",
powerSource_56547a: "Fuente de alimentación",
installation_c81b79: "Instalación",
whereIsThisAssetInItsLife_ffff43: "¿En qué etapa de su vida útil está este activo?",
criticalityOptional_491f40: "Criticidad (opcional)",
howCriticalIsThisAssetToOperations_04df20: "¿Qué tan crítico es este activo para las operaciones?",
operatingContextOptional_178f94: "Contexto operativo (opcional)",
complianceTagsOptional_2df1fc: "Etiquetas de cumplimiento (opcional)",
identifyAndTag_f946d5: "Identificar y etiquetar",
addMoreNowOrAnytimeLater_3eac61: "Agregue más ahora o en cualquier momento más adelante.",
potentialDuplicatesDetected_4b9918: "Se detectaron posibles duplicados",
moreOptions_0a1b2c: "Más opciones",
reviewMatchingAssetsBeforeCreatingANew_90559b: "Revise los activos coincidentes antes de crear un nuevo registro.",
useExistingAsset_3f06d4: "Usar activo existente",
openExisting_941fb8: "Abrir existente",
continueAnyway_011856: "Continuar de todos modos",
createLinkPossibleDuplicate_e5dcab: "Crear y vincular como posible duplicado",
markIntentionallyDistinct_cc3540: "Marcar como intencionalmente distinto",
subtype_a729bb: "Clase de documento",
loadingAsset_a104a6: "Cargando activo",
retryLoadingAsset_544af8: "Reintentar cargar activo",
onlyTheAssetsOwnerOrItsTeam_95113f: "Solo el propietario del activo o su equipo pueden editarlo. Aún puedes verlo y crear trabajo para él.",
basicDetails_42450f: "Datos básicos",
photosOptional_c0ea6e: "Fotos (opcional)",
removeAllPhotos_1329e0: "Eliminar todas las fotos",
egToyotaCamry2024_d36609: "por ej. Toyota Camry 2024",
locationNotes_259645: "Ubicación y notas",
addDetailsAboutThisAsset_ec093a: "Añade detalles sobre este activo…",
identifiers_649d28: "Identificadores",
importAssets_9158f1: "Importar activos",
invalidSharedAssetLink_1f7b4c: "Enlace de activo compartido no válido.",
sharedAsset_80c5e0: "Activo compartido",
checkingAccess_c5108c: "Comprobando acceso…",
signInWithTheAccountThatWas_5dd47c: "Inicie sesión con la cuenta que fue invitada como contacto para continuar directamente a este activo compartido.",
signInToViewThisSharedAsset_c8d337: "Inicie sesión para ver este activo compartido",
createAnAccountToViewThisShared_bef153: "Cree una cuenta para ver este activo compartido",
couldNotCheckAccess_c29580: "No se pudo verificar el acceso",
accessNotAvailable_7c84ab: "Acceso no disponible",
thisShareIsntLinkedToYourAccount_305fbe: "Este recurso compartido aún no está vinculado a su cuenta o el propietario ha revocado el acceso. Si acaba de aceptar una invitación, actualice para volver a intentarlo.",
backToAssets_caff2b: "Volver a los activos",
refreshAccess_822875: "Actualizar acceso",
thisAssetIsNotSharedWithYour_76b685: "Este activo no se comparte con su contacto vinculado o el recurso compartido se creó para un registro de contacto diferente.",
shareDeclined_292608: "Acceso compartido rechazado",
youPreviouslyDeclinedAccessToThisAsset_d9ccbb: "Anteriormente rechazaste el acceso a este activo.",
acceptSharedAsset_79b229: "Aceptar activo compartido",
declineSharedAsset_6908ef: "Rechazar activo compartido",
sharedBy_a5fe3b: "Compartido por",
youaposllBeAbleToView_bc03b3: "Podrás ver",
acceptToViewThisAssetWithThe_8df15c: "Acepta para ver este activo con el acceso indicado arriba, o rechaza para eliminar la invitación.",
assetdetail_27a5fa: "asset-detail",
templateName_0a8669: "Nombre de la lista de control *",
templateNameRequired_5db301: "Nombre de lista de control (obligatorio)",
selectOneOrMore_1489f2: "Selecciona uno o más",
updateChecklist_fce28f: "Actualizar lista de verificación",
editChecklist_8c20d6: "Editar lista de verificación",
inspectionObjective_6129b6: "Objetivo de inspección *",
describeWhatYouWantToInspectEg_1fb338: "Describa lo que desea inspeccionar (por ejemplo, verificación previa a la compra del vehículo, estado mecánico y de seguridad).",
egPrepurchaseVehicleCheckSafetyAndMechanical_871268: "por ej. Revisión previa a la compra del vehículo, estado de seguridad y mecánico.",
inspectionObjective_ce4266: "Objetivo de inspección",
categories_1c14ef: "Categorías *",
assetOptional_95db78: "Activo (opcional)",
selectAnAsset_9dd87a: "Seleccione un activo",
inspectionDepth_2b1225: "Profundidad de inspección",
targetDurationMinutesOptional_fe3727: "Duración objetivo (minutos, opcional)",
targetDurationInMinutes_1897b3: "Duración objetivo en minutos",
evidenceMode_e83c42: "Modo de evidencia",
optimizeForSpeed_56e47b: "Optimizar para velocidad",
optimizationFocusOptional_0ebfbe: "Enfoque de optimización (opcional)",
failonlyEvidenceFocusKeepsEvidenceModeOn_1f0e17: "El enfoque de evidencia solo en fallos mantiene el modo de evidencia en captura solo de fallos.",
baseTemplateOptional_d80914: "Lista de control base (opcional)",
preferToBuildItYourselfCreateManually_ae612e: "¿Prefieres crearlo tú mismo? Crear manualmente",
draftSetup_a9804f: "Configuración del borrador",
guidance_b5e0b5: "Guía",
useThisWorkspaceToIterateObjectiveDuration_76a28d: "Diga qué inspecciona y por qué. La IA redacta la lista; usted la revisa y la cambia antes de guardar nada.",
baseTemplate_54f2a3: "Lista de control base",
generatingTemplateDraft_8fdb48: "Generando borrador de lista de control…",
thisMayTakeAMoment_2cd85b: "Esto puede tardar un momento.",
buyUsageCredits_a49d2e: "Comprar créditos de uso",
templateName_954ab9: "Nombre de la lista de control",
draftRationaleAndWarnings_0ce71c: "Justificación y advertencias del borrador",
groupsItems_9bcc66: "Grupos y elementos",
draftSummary_4e141c: "Resumen del borrador",
warnings_1430f9: "Advertencias",
reviewDraft_6a9bff: "Revisar borrador",
editThenSaveOrDiscard_f1ef70: "Edita y luego guarda o descarta",
inspectionreport_04aa89: "inspection-report",
createARecurringJob_4a519d: "Crear un plan de mantenimiento",
newRecurringJob_dcc457: "Nuevo plan de mantenimiento",
couldntLoadRecurringJobs_cbd362: "No se pudieron cargar los planes de mantenimiento",
noRecurringJobsYet_c5a4c5: "Aún no hay planes de mantenimiento",
openCurrentJob_cf8169: "Abrir orden de trabajo actual",
end_a2bb9d: "Fin",
jobreport_c30f90: "job-report",
pleaseWaitFinalisingYourSubscription_9839a5: "Espere, finalizando su suscripción.",
openPrivacyAmpData_453313: "Abrir Privacidad y datos",
retryLoadingYourWorkspace_be5137: "Reintente cargar su espacio de trabajo",
signInToViewThisQuoteRequest_317846: "Inicie sesión para ver esta solicitud de presupuesto",
thisInviteWasSentToYourEmail_d77859: "Esta invitación se envió a su dirección de correo electrónico. Inicie sesión (o cree una cuenta gratuita con ese correo electrónico) y la solicitud de presupuesto se abrirá automáticamente.",
retryLoadingQuoteInvitation_7c3b72: "Reintentar cargar la invitación de presupuesto",
ifTheInviteWasSentToA_2463c0: "Si la invitación se envió a una dirección de correo electrónico diferente, inicie sesión con esa dirección para abrirla.",
retryLoadingQuoteContext_2406e9: "Reintentar cargar el contexto del presupuesto",
loadingQuoteDetailsAndSavedDraft_3c2a11: "Cargando los detalles del presupuesto y el borrador guardado",
requestDetails_bf5023: "Detalles de la solicitud",
additionalContextFromClient_1d46de: "Contexto adicional (del cliente)",
yourQuote_756213: "Tu presupuesto *",
yourQuoteRequired_afd50e: "Tu presupuesto (obligatorio)",
durationEstimateOptional_ace4e9: "Duración estimada (opcional)",
availabilityWindowOptional_9e64b7: "Franja de disponibilidad (opcional)",
materialsIncluded_5ffbdc: "Materiales incluidos",
materialsDetails_72ea3e: "Detalles de los materiales",
details_4dade5: "Detalles…",
warrantyOptional_010797: "Garantía (opcional)",
eg12Months_0ff628: "por ej. 12 meses",
additionalDetails_04831c: "Detalles adicionales…",
attachmentsOptional_106896: "Adjuntos (opcional)",
loadingInspection_1ad221: "Cargando inspección…",
whatTheInspectionFound_b53913: "Qué encontró la inspección",
avgCondition_6b3737: "Estado medio",
needsDecision_229276: "Necesita decisión",
inspectorNotes_2f7e20: "Notas del inspector",
recommendedRepair_a70281: "Reparación recomendada",
labourMaterials_08ee77: "Mano de obra y materiales",
estimatedCost_35caa4: "Coste estimado",
jobsFromThisReport_fa5fee: "Órdenes de trabajo de este informe",
tapAJobToSeeFullDetails_fe7c8c: "Toque una orden de trabajo para ver todos los detalles y el estado.",
couldNotSyncReview_375861: "No se pudo sincronizar la revisión",
inspectionreview_077ff2: "inspection-review",
acceptTeamInvitation_2f956c: "Aceptar invitación del equipo",
acceptInvitation_f41d2a: "Aceptar invitación",
declineTeamInvitationForNow_7ce799: "Rechazar invitación al equipo por ahora",
yourTeams_d63712: " Tus equipos",
createNewTeam_a8d9ef: "Crear nuevo equipo",
addTeam_046c3a: "Agregar equipo",
noTeam_178b88: "Sin equipo",
createATeamToCollaborateInviteContractors_bf3947: "Cree un equipo para colaborar, invitar a contratistas y asignar órdenes de trabajo.",
createTeam_8d826c: "Crear equipo",
createTeam_8b8973: "Crear equipo",
giveYourTeamAName_0161ea: "Dale un nombre a tu equipo",
teamName_9b11ed: "Nombre del equipo",
egAcmeInspections_60df82: "por ej. Inspecciones Acme",
newTeam_7ff544: "Nuevo equipo",
searchMembers_bdad23: "Buscar miembros…",
searchMembers_a1d97a: "Buscar miembros",
usedToMatchWorkToPeopleA_4d8242: "Se usa para asignar el trabajo a las personas adecuadas. Una orden de trabajo puede marcar una habilidad como “imprescindible”, y quien no la tenga no se propone para ella.",
makeOwner_f99257: "Hacer propietario",
resetTwofactor_4efb84: "Restablecer la verificación en dos pasos",
removeMember_1c31d1: "Eliminar miembro",
closeMenu_6c9fc9: "Cerrar menú",
invitations_4b0b9f: " Invitaciones",
workspaceMembershipGrantsAppAccessContactRecords_e5c34b: "Ser miembro del espacio de trabajo da acceso a la aplicación. Los registros de contacto permanecen separados y se pueden vincular al trabajo sin convertirse en miembros.",
inviteANewTeamMember_52559c: "Invitar a un nuevo miembro del equipo",
invitePeople_e1eb97: "Invitar personas",
emailAddressesForInvitationsOnePerLine_5e7e7e: "Direcciones de correo electrónico para invitaciones, una por línea",
addOneOrMoreAddressesSeparatedBy_162bd6: "Agregue una o más direcciones, separadas por una nueva línea o coma.",
whatShouldTheyBeAbleToDo_224294: "¿Qué deberían poder hacer?",
cancelInviteForm_156d89: "Cancelar formulario de invitación",
noPendingInvitations_8d0735: "No hay invitaciones pendientes",
showMeHowToInviteAMember_6b43bc: "Muéstrame cómo invitar a un miembro",
showMeHowToInviteSomeone_61b6a4: "Muéstrame cómo invitar a alguien",
teamSettings_373140: " Ajustes del equipo",
workspaceDefaultsAccount_4ae7a6: "Valores predeterminados del espacio de trabajo (cuenta)",
baselineDefaultsForTheWorkspaceYouCan_f78072: "Valores predeterminados de referencia para el espacio de trabajo. También puedes configurarlos en Cuenta → Configuración si no estás en un equipo.",
workspaceCommunication_2c579b: "Comunicación del espacio de trabajo",
teamOverrides_4c6f5e: "Ajustes propios del equipo",
overrideThisTeamOrKeepItInheriting_1d3b9a: "Personalice los ajustes de este equipo o manténgalo con los valores predeterminados del espacio de trabajo.",
teamCurrencyMode_f9eea7: "Modo moneda del equipo",
inheritWorkspace_879a54: "Heredar espacio de trabajo",
override_842192: "Personalizar",
teamCommunicationMode_d0ba75: "Modo de comunicación en equipo",
effectiveDefaultsInThisContext_3905f8: "Valores predeterminados efectivos en este contexto",
onlyWorkspaceOwnersAndAdminsCanChange_325bf7: "Solo los propietarios y administradores del espacio de trabajo pueden cambiar estos valores predeterminados.",
openWorkspaceAIAndAutomationAudit_f2fd0f: "Abrir la auditoría de IA y automatización del espacio de trabajo",
workspaceAIAutomationAudit_79db57: "Auditoría de automatización e inteligencia artificial del espacio de trabajo",
renameTeam_bbd28e: "Cambiar nombre del equipo",
leaveTeam_b445f9: "Dejar el equipo",
transferOwnership_a6819e: "Transferir propiedad",
deleteTeam_a9661e: "Eliminar equipo",
chooseAMemberToOfferOwnershipTo_ee74d9: "Elige un miembro al que ofrecer la propiedad. Debe aceptarla; entonces pasarás a ser administrador.",
input_b568d4: "Entrada",
plainlanguageGuideForThisTrigger_546a3a: "Guía en lenguaje sencillo para este activador",
whatYouCanPassToAnotherSystem_3385b2: "Lo que puedes pasar a otro sistema",
sendingDataOutTypicalWebhookStep_9fa855: "Envío de datos (paso típico de webhook)",
fixedPartReplaceTheExampleWebAddress_b73594: "Parte fija: sustituya la dirección web de ejemplo por la suya",
automaticPartFilledFromThisTriggerWhen_a65fba: "Parte automática: se rellena con este disparador cuando se ejecuta la receta",
optionalFiltersAbove_b7c00b: "Filtros opcionales (arriba)",
trigger_56cc41: "trigger.",
trigger_082e86: "trigger.…",
advancedRecipeBuilder_799724: "Creador de recetas avanzado",
fullTriggerConditionAndStepControlFor_c176d8: "Control completo de disparadores, condiciones y pasos para usuarios avanzados. Usa el modo guiado para nuevas automatizaciones cuando encaje una plantilla.",
triggerCatalog_b27d78: "Catálogo de disparadores",
actionCatalog_44816c: "Catálogo de acciones",
howToCreateARecipe_18bda4: "Cómo crear una receta",
recipesConnectATriggerWhenToOne_9c1ff3: "Las recetas conectan un disparador (cuándo) con una o más acciones (qué). Nada se ejecuta en producción hasta que actives el borrador desde la lista de la derecha.",
recipeWizard_6830a5: "Asistente de recetas",
buildADraftBelowThenActivateIt_219398: "Cree un borrador a continuación y luego actívelo desde la lista de Recetas.",
syncCompletedInspectionsToCRM_2594a7: "Sincronizar inspecciones completadas con CRM",
optionalInternalNote_dedb5c: "Nota interna opcional",
triggerType_a8b3dc: "Tipo de disparador",
chooseWhenThisRecipeShouldRunOptions_065235: "Elija cuándo debe ejecutarse esta receta. Las opciones están agrupadas por tema; el código corto debajo de cada nombre es una referencia opcional si asigna campos desde otro sistema.",
selectedTrigger_4573c4: "Activador seleccionado",
intervalMinutes_617c3f: "Intervalo en minutos",
conditionsOptional_d2f0fb: "Condiciones (opcional)",
onlyRunWhenTheIncomingEventMatches_c87bd3: "Ejecutar solo cuando el evento entrante coincida con cada fila que añadas. Usa nombres de campo cortos de tu sistema de origen (por ejemplo, status o id del registro). Déjalo vacío para ejecutarlo cada vez que se active este disparador.",
jSONPath_a8136f: "Ruta JSON",
dataobjectstatus_f2b5ba: "data.object.status",
value_8dce17: "Valor",
completedOrOpenpaused_f935e5: "completed o [\"open\",\"paused\"]",
addCondition_42fe69: "Agregar condición",
noFiltersEveryMatchingTriggerRunsThe_5cdf5e: "Sin filtros: cada disparador coincidente ejecuta las acciones.",
actionsRunInOrder_dd55c2: "Acciones (se ejecutan en orden)",
pickWhatEachStepShouldDoThen_8b8ac5: "Elija lo que debe hacer cada paso, luego pegue o edite el JSON. Utilice el cuadro gris debajo de su activador para ver ejemplos listos para copiar y cambiar el nombre de los campos para que coincidan con su otro software.",
actionType_fece43: "Tipo de acción",
fixedValuesJSON_3002d2: "Valores fijos (JSON)",
valuesFromTheEventJSON_11f1b5: "Valores del evento (JSON)",
urltriggerdatawebhookcallbackUrl_24747a: "{\"url\":\"trigger.data.webhook.callbackUrl\"}",
addAction_2824f0: "Agregar acción",
stableKeysScopesSchemasSamplesAndConnector_a9453b: "Claves estables, ámbitos, esquemas, ejemplos y sugerencias de conectores para desarrolladores externos.",
zapier_569964: "Zapier",
powerAutomate_81fa07: "Power Automate",
queuedSkippedSucceededAndFailedRecipeRuns_ceb06e: "Ejecuciones de recetas en cola, omitidas, exitosas y fallidas con reintento manual.",
noRunsHaveBeenRecordedYet_cfe5db: "Aún no se han registrado ejecuciones.",
importAssetsOrContactsFromACSV_8bb4c4: "Importe activos o contactos desde un archivo CSV o Excel. Asigne columnas, obtenga una vista previa de la validación y luego cree registros.",
fileIntegrationHealth_2a85ee: "Estado de la integración de archivos",
credentialsScopeRunsUnderYourSignedinWorkspace_7e301a: "Credenciales/alcance: se ejecuta con los permisos de tu sesión en el espacio de trabajo; el contenido del archivo se asigna antes de crear los registros.",
chooseACsvOrXlsxFileThe_d63529: "Elija un archivo .csv o .xlsx. La primera fila debe contener encabezados de columna.",
chooseFileToImport_7450d5: "Elija el archivo para importar",
whatAreYouImporting_15be02: "¿Qué estás importando?",
startOver_51dd91: "Empezar de nuevo",
mapColumnsAndOptionalDefaults_b4665a: "Asignar columnas y valores predeterminados opcionales",
flowFileObjectTypeAssetscontactsThisStep_1f9978: "Flujo: archivo → tipo de objeto (activos/contactos) → este paso → Vista previa (validación) → Importar. Aquí, elija qué columna de su hoja de cálculo alimenta cada campo de la aplicación. Si falta una columna o las celdas están vacías, establezca un valor predeterminado a continuación: llena cada fila donde falta ese valor. Los campos marcados * necesitan una columna o un valor predeterminado. La vista previa muestra problemas a nivel de fila (por ejemplo, el subtipo no es válido para el tipo de activo de esa fila) antes de guardar algo.",
browseAllowedSubtypeValuesByAssetType_a490ea: "Explorar valores de subtipo permitidos por tipo de activo",
browseAllowedSubtypeValuesByAssetType_580a2c: "Explorar valores de subtipo permitidos (por tipo de activo)",
sameFieldsAsWhenYouAddAn_66723f: "Los mismos campos que cuando agrega un activo desde la pestaña Activos (creación rápida).",
sameToplevelFieldsAsAssetDetailsSubtype_f2742b: "Los mismos campos de nivel superior que Activo → Detalles (subtipo, criticidad y listas de etiquetas). El conjunto de opciones estructurado JSON no se importa aquí; use texto sin formato y los valores de etiqueta permitidos enumerados en la referencia anterior.",
sameAsAddContactWhoThisRecord_ba62a1: "Igual que Agregar contacto: a quién representa este registro.",
whoCanSeeThisContactDefaultRoles_144799: "Quién puede ver este contacto; roles predeterminados si el archivo no tiene ninguno.",
defaultIfEmpty_4d3688: "Predeterminado si está vacío",
optionalUseForEveryRowWhenBlank_6bd308: "Opcional: usar para cada fila cuando esté en blanco",
oneDefaultSubtypeAppliesToEveryRow_1adca0: "Se aplica un subtipo predeterminado a cada fila con una celda de subtipo vacía. Si su archivo combina tipos de activos, ese valor debe ser válido para todos ellos; generalmente use una columna Subtipo en su lugar.",
whenAMatchingRecordAlreadyExists_2bc530: "Cuando ya existe un registro coincidente",
updateMatchingRecords_acbd0a: "Actualizar registros coincidentes",
matchAssetsByExternalIDAndContacts_440e6c: "Haga coincidir activos por ID externo y contactos por correo electrónico.",
skipMatchingRecords_c0ae31: "Omitir registros coincidentes",
leaveExistingAssetWRXRecordsUnchanged_8f82ad: "Deje los registros AssetWRX existentes sin cambios.",
everyRowHasOneExplicitActionValidation_3af4e8: "Cada fila tiene una acción explícita. Los errores de validación no se escribirán.",
dataToImport_06e654: "Datos para importar",
valuesReadFromFileThisRowWill_bd4d2f: "Valores leídos del archivo (esta fila no se importará)",
noNonemptyFieldsOnThisRow_33c6ae: "No hay campos que no estén vacíos en esta fila.",
noMappedValuesForThisRow_b90088: "No hay valores asignados para esta fila.",
importFinished_c3e89b: "Importación finalizada",
created_05e8fd: "Creados ",
andMore_c2145e: "…y más",
importAnotherFile_6dc962: "Importar otro archivo",
closeSubtypeReference_be22c0: "Cerrar referencia de subtipo",
subtypeValuesImport_0c957e: "Valores de subtipo (importar)",
useTheCodeOrLabelInThe_0a2125: "Utilice el código o etiqueta en la columna Subtipo. El valor debe coincidir con el tipo de activo en la misma fila (o su tipo predeterminado).",
connected_3dfd4d: "connected.*",
connectedruleexecuted_594141: "connected.rule.executed",
temperature_7033e9: "temperature",
xApiKey_cef935: "X-Api-Key",
httpspartnerexamplecomhooksassetwrx_79a38c: "https://partner.example.com/hooks/assetwrx",
jobId_f3d2e2: "jobId",
status_48a366: "status",
title_3c6de1: "title",
tESTASSET001_6a6a4b: "PRUEBA-ACTIVO-001",
opsCopilot_5a267c: "Copiloto de operaciones",
httpsmcpexamplecom_a938f2: "https://mcp.example.com",
httpsexamplecomwebhooksassetwrx_fc61e9: "https://example.com/webhooks/assetwrx",
retryTestConnection_c9f32a: "Reintentar la conexión de prueba",
refreshLogs_f970c3: "Actualizar registros",
credentialAndScopeClarity_6593d1: "Claridad de credenciales y alcance",
assistantAccessStillRequiresWorkspaceEnablementPlus_df3128: "El acceso del asistente aún requiere la habilitación del espacio de trabajo más la aprobación por herramienta/recurso en el catálogo.",
retryConnectionTest_4382ef: "Reintentar prueba de conexión",
whatThisWizardSetsUp_ced2db: "Lo que configura este asistente",
thisExposesAssetWRXItselfAsAFirstparty_a9b397: "Esto expone AssetWRX como servidor MCP propio para el espacio de trabajo actual. Los clientes MCP externos obtienen lecturas limitadas al espacio de trabajo y herramientas de escritura basadas en propuestas, solo a través del backend.",
assetWRXSystemConnector_bbcfee: "Conector del sistema AssetWRX",
thisAssistantConnectorIsAlwaysAvailableFor_6e5481: "Este conector asistente siempre está disponible para el espacio de trabajo, oculto para los usuarios normales y no se puede eliminar.",
whatYouGet_8ac7aa: "Lo que obtienes",
proposalfirstWritesAuditHistoryAndPerworkspaceEnablement_4086cb: "Cambios con propuesta previa, historial de auditoría y habilitación por espacio de trabajo.",
readsExposedInV1_a02d0c: "Lecturas expuestas en v1",
workspaceSummaryDashboardStatusAssetsInspectionsJobs_ac16ca: "Resumen del espacio de trabajo, estado del panel, activos, inspecciones, órdenes de trabajo, listas de control y lecturas del contexto del asistente cuando sea seguro.",
builtinAssistantCapabilities_e47a5d: "Capacidades de asistente integradas",
writeBehaviorInV1_73d808: "Comportamiento de escritura en v1",
materialToolsCreateProposalsFirstNothingCommits_9951b2: "Las herramientas que hacen cambios crean primero propuestas. Nada se ejecuta hasta que un propietario o administrador lo aprueba aquí (reciben un aviso), salvo que el propietario permita esa acción sin aprobación; después el cliente llama a `confirm_proposed_action`.",
enableWorkspaceExposure_3b8aed: "Habilitar exposición del espacio de trabajo",
turnOnTheEndpointConfirmTheWorkspace_c9acbe: "Activa el endpoint, confirma el estado del espacio de trabajo y define cuánto tiempo permanecen válidas las propuestas de escritura antes de caducar.",
endpoint_92ec63: "Endpoint",
proposalTTLMinutes_b08405: "TTL de la propuesta (minutos)",
validRange5To1440MinutesDefault_81859c: "Rango válido: 5 a 1440 minutos. Predeterminado: 30 minutos.",
approveToolsAndResources_6e4769: "Aprobar herramientas y recursos",
keepOnlyTheWorkspacesafeMCPSurfaceYou_433b1d: "Conserve solo la superficie MCP segura para el espacio de trabajo que desea que vean los clientes externos. Las filas deshabilitadas están ocultas de `tools/list` y `resources/list`.",
noFirstpartyMCPToolsAreRegisteredYet_a45543: "Aún no se han registrado herramientas MCP propias.",
noFirstpartyMCPResourcesAreRegisteredYet_58e317: "Aún no se han registrado recursos MCP propios.",
serviceaccountKeysAndScopes_8f39e0: "Claves y alcances de la cuenta de servicio",
thisWizardDoesNotMintSecretsDirectly_ba8449: "Este asistente no crea secretos directamente. Los clientes MCP externos deben usar las claves API de la cuenta de servicio del espacio de trabajo existente creadas en claves y acceso API.",
requiredScopeModel_206642: "Modelo de alcance requerido",
readsRequireMcpreadPlusTheRelevantDomain_efecc5: "Las lecturas requieren `mcp:read` más el alcance de lectura del dominio relevante, como `assets:read`.",
writeProposalsRequireMcpinvokePlusTheRelevant_bde894: "Las propuestas de escritura requieren `mcp:invoke` más el alcance de escritura relevante, como `jobs:write`.",
proposalConfirmationAndCancellationStayBoundTo_b8a213: "La confirmación y cancelación de la propuesta permanecen vinculadas al mismo espacio de trabajo y clave solicitante.",
clientSetupExample_dde719: "Ejemplo de configuración del cliente",
safetyDefaults_f1e85c: "Valores predeterminados de seguridad",
neverHandOutUnlessTheClientIs_26c700: "Nunca entregue `*` a menos que el cliente sea de plena confianza. Prefiera primero las claves de solo lectura y luego las claves separadas con capacidad de propuesta para automatizaciones controladas.",
reviewProposalsAndAuditHistory_945ebe: "Revisar propuestas e historial de auditoría.",
useThisStepToConfirmExternalClients_209a95: "Utilice este paso para confirmar que los clientes externos solo leen los recursos previstos y que las acciones que hacen cambios siguen pasando primero por una propuesta y quedan auditadas.",
proposalHistory_0f9af9: "Historial de propuestas",
noFirstpartyMCPProposalsYet_62c81f: "Aún no hay propuestas de MCP propias.",
mcpProposalApprove: "Aprobar",
mcpProposalDecline: "Rechazar",
mcpProposalDecideFailed: "No se pudo registrar la decisión",
mcpAwaitingApprovalTitle: "Pendiente de su aprobación ({{count}})",
mcpAwaitingApprovalHint: "Un asistente de IA ha pedido hacer estos cambios. No ocurre nada hasta que los apruebes; las solicitudes rechazadas o caducadas nunca se ejecutan.",
mcpApproveAll: "Aprobar todas ({{count}})",
mcpDeclineAll: "Rechazar todas ({{count}})",
mcpApproveAllConfirmTitle_one: "¿Aprobar {{count}} solicitud?",
mcpApproveAllConfirmTitle_many: "¿Aprobar {{count}} solicitudes?",
mcpApproveAllConfirmTitle_other: "¿Aprobar {{count}} solicitudes?",
mcpApproveAllConfirmBody: "Se aprueban todas las solicitudes \"{{action}}\" pendientes aquí y la IA podrá ejecutar cada una.",
mcpDeclineAllConfirmTitle_one: "¿Rechazar {{count}} solicitud?",
mcpDeclineAllConfirmTitle_many: "¿Rechazar {{count}} solicitudes?",
mcpDeclineAllConfirmTitle_other: "¿Rechazar {{count}} solicitudes?",
mcpDeclineAllConfirmBody: "No se ejecutará ninguna de las solicitudes \"{{action}}\" pendientes aquí.",
mcpShowAll: "Mostrar las {{count}}",
mcpShowFewer: "Mostrar menos",
mcpApprovalRequired: "Requiere aprobación",
mcpApprovalNotRequired: "Se ejecuta sin aprobación",
mcpWaiveApprovalTitle: "¿Permitir que \"{{name}}\" se ejecute sin aprobación?",
mcpWaiveApprovalBody: "Un asistente de IA podrá hacer este cambio sin que un propietario o administrador lo apruebe. Puedes volver a exigir aprobación en cualquier momento.",
mcpWaiveApprovalConfirm: "Ejecutar sin aprobación",
mcpApprovalUpdateFailed: "No se pudo cambiar la aprobación de esta acción.",
invocationAudit_06c951: "Auditoría de invocación",
noFirstpartyMCPInvocationHistoryYet_352e60: "Aún no hay historial de invocaciones de MCP propio.",
assetWRXMCPExposure_b699b4: "Exposición MCP de AssetWRX",
exposeThisWorkspaceAsAFirstpartyMCP_7fae12: "Exponga este espacio de trabajo como servidor MCP propio con lecturas limitadas al espacio de trabajo, cambios con propuesta previa e historial de auditoría.",
firstpartySetup_16908a: "Configuración propia",
loadingAssetWRXMCPExposure_4cc589: "Cargando la exposición MCP de AssetWRX...",
loadingAssetWRXMCPExposure_ec357e: "Cargando la exposición MCP de AssetWRX…",
workspaceControls_3cfefd: "Controles del espacio de trabajo",
useServiceaccountKeysWithMcpreadForResources_d8fd58: "Utilice claves de cuenta de servicio con `mcp:read` para recursos y `mcp:invoke` más ámbitos de escritura de dominio para herramientas con capacidad de propuesta.",
exposedTools_50a475: "Herramientas expuestas",
materialActionsStayProposalfirstEvenWhenEnabled_40b9b8: "Las acciones que hacen cambios siguen pasando primero por una propuesta, incluso cuando se habilitan aquí.",
exposedResources_420463: "Recursos expuestos",
resourceTemplatesStayWorkspacescopedAndAreFiltered_664498: "Las plantillas de recursos permanecen en el ámbito del espacio de trabajo y se filtran por ámbitos de la cuenta de servicio.",
hideMoreActions_dd5915: "Ocultar más acciones",
hideActions_affb29: "Ocultar acciones",
showMoreActions_2ff0fa: "Mostrar más acciones",
searching_ba2b5a: "Buscando...",
aICanDraftThisRepairJob_247024: "La IA puede redactar esta orden de trabajo de reparación",
why_d77989: "¿Por qué?",
autoprepFollowupJobsAndScheduleTighteningSuggested_8be7b7: "Se sugieren preparación automática, órdenes de trabajo de seguimiento y ajuste de la programación",
reviewAutomations_a7cc10: "Revisar automatizaciones",
workingOnThisText_24726e: "Trabajando en este texto...",
acceptIndividuallyOrInBulkEachWrites_bf195f: "Acepte individualmente o en masa: cada uno escribe el borrador en el elemento correspondiente a continuación.",
scheduledDate_b41cf0: "Fecha programada",
selectADate_642b09: "Selecciona una fecha",
chooseAssignee_3f1566: "Elegir responsable",
searchRequests_f13d82: "Buscar solicitudes",
noRequestsMatchYourSearch_a6c94d: "Ninguna solicitud coincide con su búsqueda.",
reportResponsePending_44c9b7: "Informe de respuesta pendiente",
completionReviewPending_b4145c: "Revisión de finalización pendiente",
confirmDate_14424a: "Confirmar fecha",
confirmTheScheduledDate_b2fc2c: "Confirmar la fecha programada",
requestADifferentTime_0d7d3e: "Solicitar otro horario",
cancelRequest_84837a: "Cancelar solicitud",
cancelThisRequest_f56a63: "Cancelar esta solicitud",
preferredDate_921625: "Fecha preferida",
sendTheRescheduleRequest_b5dc9f: "Enviar la solicitud de reprogramación",
cancelTheRescheduleRequest_9fb111: "Cancelar la solicitud de reprogramación",
chooseNextAction_94f5b9: "Elige la siguiente acción",
chooseAWorkPathTheRequestDetails_804dd3: "Elija una ruta de trabajo; los detalles de la solicitud permanecen precompletados para su confirmación, asignación y calendario.",
recommended_9ef937: "Recomendado",
createWorkFromRequest_47ff21: "Crear trabajo a partir de solicitud",
confirmOwnerDueDatePriorityAndInstructions_8bc8fe: "Confirme el propietario, la fecha de vencimiento, la prioridad y las instrucciones antes de crear la orden de trabajo.",
inspectRequest_5569d2: "Inspeccionar a partir de la solicitud",
chooseStartNowAssignOrScheduleAfter_c334b8: "Elija comenzar ahora, asignar o programar después de confirmar la lista de verificación y el alcance",
whoApprovesWorkOnThisAsset_2e42d2: "¿Quién aprueba el trabajo en este activo?",
inspectionConditionTrend_179a6f: "Tendencia de condición de inspección",
searchNameCompanyRole_baab25: "Buscar nombre, empresa, rol",
tryClearingTheSearchOrFilters_0818c7: "Intente borrar la búsqueda o los filtros.",
roleCompany_feef85: "Rol · Empresa",
changeAccess_fec7d5: "Cambiar acceso",
overdueWorkDocumentRiskAndOpenInspection_66d5d1: "Trabajo atrasado, riesgo de documentos y estado de inspección abierta.",
noUrgentItemsRightNow_d3111a: "No hay elementos urgentes en este momento.",
responsibleTeam_fd5898: "Equipo responsable",
approvesWork_3d9f4c: "Aprueba el trabajo",
signsOffInspectionsAndJobCompletionsAnd_35b573: "Aprueba inspecciones y finalizaciones de órdenes de trabajo, y valida documentos.",
draftInProgress_82d43c: "Borrador y en progreso",
healthComplianceAndRiskAreScoredFrom_3c3736: "El estado, el cumplimiento y el riesgo se califican a partir del registro completo y se muestran al propietario y al equipo del activo.",
noDocumentsMatchTheCurrentFilters_193238: "Ningún documento coincide con los filtros actuales.",
noDocumentDatesThisMonth_01f2cb: "No hay fechas de documentos este mes.",
noDocumentsOnThisDay_ed643f: "No hay documentos en este día.",
plannedRunsWorkInFlightAndCompleted_12c7f2: "Ejecuciones planificadas, trabajo en ejecución e informes completados para este activo.",
startAnInspectionToEstablishConditionAnd_5e3ce5: "Inicie una inspección para establecer el estado y el trabajo de seguimiento.",
completedCancelledInspections_118586: "Inspecciones completadas y canceladas",
scheduledActiveAndClosedWorkTiedTo_bdec69: "Trabajo programado, activo y cerrado vinculado a este activo.",
noJobsForThisAsset_778118: "No hay órdenes de trabajo para este activo",
createFollowupWorkForThisAssetWhen_346e1d: "Cree trabajo de seguimiento para este activo cuando algo necesite acción.",
completedCancelledJobs_9dae91: "Órdenes de trabajo completadas y canceladas",
searchKnowledge_42cfc4: "Buscar conocimiento",
addToKnowledge_52f38f: "Añadir al conocimiento",
publicIntake_b9f61c: "Solicitudes públicas",
turnThisOnToGetAQR_7dd031: "Active esto para obtener un código QR y un enlace que cualquiera puede usar para informar un problema en este activo; no es necesario tener una cuenta ni iniciar sesión.",
publicIntakeQRCode_71844b: "Código QR de solicitudes públicas",
howItWorks_1dd6a1: "Cómo funciona",
"1PrintOrDisplayThisQRCode_b4b58b": "1. Imprima o muestre este código QR en o cerca del activo.",
"2AnyoneScansItWithTheirPhone_399e27": "2. Cualquiera lo escanea con la cámara de su teléfono, sin aplicación ni inicio de sesión.",
"3TheyDescribeTheIssueAndIt_0cf748": "3. Describen el problema y aparece en sus solicitudes.",
printThisQRCode_355b08: "Imprime este código QR",
printQR_3d3e5d: "Imprimir QR",
copyIntakeLink_d55587: "Copiar enlace de solicitudes",
printOrShareTHISCodeItsThe_081cb8: "Imprime o comparte ESTE código: es el único que funciona sin una cuenta. La propia etiqueta QR del activo abre el activo para los miembros del equipo que hayan iniciado sesión y le pedirá a una persona externa que inicie sesión.",
publicIntakeIsOnButThisApp_37c7e6: "Las solicitudes públicas están activadas, pero esta compilación de la aplicación no tiene una dirección web pública a la que apuntar el código QR, por lo que aún no hay ningún enlace para compartir. Se configura en el momento de la compilación (EXPO_PUBLIC_WEB_APP_URL); pídale a quien produjo esta compilación que la configure. La aplicación web no se ve afectada.",
closePublicIntake_83ee14: "Cerrar solicitudes públicas",
clearFilter_b667d6: "Limpiar filtro",
retire_c9714c: "Retirar definitivamente",
cancelRetiring_021841: "Cancelar la retirada definitiva",
thisAssetIsStillInServiceTake_6d33c8: "Este activo todavía está en servicio. Primero sáquelo de servicio y luego retire el registro.",
decommissionThisAssetFirst_3dba4e: "Ponga este activo fuera de servicio primero",
decommissionFirst_449932: "Primero, ponerlo fuera de servicio",
whyIsItBeingRetired_424b30: "¿Por qué se retira?",
anythingTheRecordShouldSayEgReplaced_39f4f8: "Lo que deba constar en el registro; p. ej., sustituido por la unidad B-12.",
retirementNote_69e12e: "Nota de baja",
disposalOptional_664c05: "Venta o desecho (opcional)",
recipientBuyerScrapYardLessor_bc1312: "Destinatario: comprador, desguace, arrendador",
disposalRecipient_0bcdb7: "Destinatario (venta o desecho)",
disposalValue_7e69e8: "Valor de venta o desecho",
whatHappens_d208fd: "Qué ocurrirá",
retireThisAsset_843886: "Retirar definitivamente este activo",
editSharedAccess_874a55: "Editar acceso compartido",
canRequestWorkLetsThemSubmitInspection_66303c: "\"Puede solicitar trabajo\" les permite enviar solicitudes de inspección u orden de trabajo; \"Puede ver\" es de solo lectura. Ambos pueden ver órdenes de trabajo e inspecciones.",
documentsArePrivateByDefaultTurnThis_f79dc7: "Los documentos son privados de forma predeterminada. Active esto para permitirles descargar los archivos del activo.",
canDownloadDocuments_d483c0: "Puede descargar documentos",
thisContactIsNotLinkedToAn_cfbe9b: "Este contacto aún no está vinculado a un usuario de la aplicación. Guardar compartirá el activo, pero deben aceptar una invitación de contacto antes de poder verlo en la aplicación.",
relationshipToThisAsset_cc572f: "Relación con este activo",
moreRelationships_1c2d3e: "Más relaciones",
howThisContactIsLinkedOnThe_b75d5d: "Cómo se vincula este contacto en el registro de activo (organización/inquilino). Seleccione una o más relaciones.",
whatThisContactCanDoInThe_1f7b90: "Qué puede hacer este contacto en el espacio de trabajo de activos compartidos. \"Puede solicitar trabajo\" les permite enviar solicitudes de inspección u orden de trabajo; \"Puede ver\" es de solo lectura. Ambos pueden ver órdenes de trabajo e inspecciones.",
saveShare_bcf6ed: "Guardar acceso compartido",
qR_45e7a1: "QR",
scanOrPrintLabelsForThisAsset_c3fdde: "Escanee o imprima etiquetas para este activo.",
print_5b221e: "Imprimir",
qRCodeWillBeGeneratedWhenAsset_31ea4e: "El código QR se generará al guardar el activo",
assetIntelligence_d0cf4b: "Inteligencia de activos",
conditionNotRatedYet: "Estado sin valorar todavía · necesita una inspección",
why_21e2ca: "¿Por qué?",
keepTheCurrentSchedule_ade385: "Mantener el horario actual",
keepCurrentSchedule_24ceb0: "Mantener programación actual",
operationalReadiness_f83f30: "Disponibilidad operativa",
noReadinessChecksCurrentlyNeedAttention_8a0ffe: "Ninguna comprobación de preparación necesita atención ahora",
foundations_2efa1e: "Fundamentos",
topCommandsForThisAsset_43db45: "Comandos principales para este activo",
seeAll_9ff264: "Ver todos →",
noCompletedOrApprovedInspectionCyclesAre_58ad5b: "No se registran ciclos de inspección completados o aprobados.",
noLinkedAssetsYet_f0421d: "Aún no hay activos vinculados.",
viewRelationships_855c37: "Ver relaciones →",
noOpenJobsOrInprogressInspectionsAre_c07385: "No se registran órdenes de trabajo abiertas ni inspecciones en curso.",
sharedContactsAndQRScannersReportIssues_ece9d2: "Los contactos compartidos y los escáneres QR informan problemas directamente en su cola de trabajo.",
addArticle_2f4275: "Agregar artículo",
shareLibrary_4057e3: "Compartir biblioteca",
signInToSeeThisKnowledge_4eaa03: "Inicia sesión para ver este conocimiento",
yourSessionHasExpiredSoTheseArticles_f87fa2: "Tu sesión ha caducado, así que estos artículos no se pueden cargar. Vuelve a iniciar sesión para continuar.",
couldnrsquotLoadKnowledge_da1c79: "No se pudo cargar el conocimiento",
tryLoadingKnowledgeAgain_1b6aa1: "Intente cargar conocimientos nuevamente",
refineArticles_d1b417: "Refinar artículos",
kind_e00ac2: "Tipo",
egElectrical_0b7339: "por ej. eléctrico",
egBoilerAnnual_18e665: "por ej. caldera, anual",
pinnedOnly_bd8de5: "Solo fijados",
egBoilerResetProcedure_91545f: "p. ej., procedimiento de reinicio de la caldera",
uRL_0e2d9b: "URL",
https_1a6627: "https://…",
content_4f9be0: "Contenido",
writeStepsAnswerOrNotes_974f8b: "Escribe pasos, respuestas o notas...",
chooseFile_3fd558: "Elige archivo…",
setTitlecategoryAboveBeforeUploadingOptional_cea97d: "Establezca el título/categoría arriba antes de cargar (opcional).",
shortSummaryOrContext_239731: "Breve resumen o contexto",
pinned_f93121: "Fijado",
shareKnowledge_a28e38: "Compartir conocimientos",
shareWith_134bfa: "Compartir con",
chooseContactToShareWith_f8c887: "Elija contacto para compartir",
noEmailOnContact_2730d7: "No hay correo electrónico de contacto",
chooseContact_4a3f8f: "Elija contacto…",
createLinkCopy_460e24: "Crear enlace y copiar",
activeShares_8d41b3: "Accesos compartidos activos",
revokeShare_1d9e95: "Revocar acceso compartido",
addAtLeastTwoAssetsInThis_92640d: "Agregue al menos dos activos en este alcance para crear vínculos entre ellos.",
startInWork_47c346: "Empezar en Trabajo",
propertyCategory_dfd0bc: "Categoría de la propiedad",
propertySubtype_7092d7: "Subtipo de propiedad",
vehicleClass_1807bf: "Clase de vehículo",
equipmentClass_f1c8f7: "Clase de equipo",
domain_9b1091: "Ámbito",
furnished_8ab38e: "Amueblado",
operatingContext_c28bb5: "Contexto operativo",
usageType_0193f0: "Tipo de uso",
mounting_26ae06: "Montaje",
safetyClass_c2825e: "Clase de seguridad",
environment_d443a1: "Entorno",
riskTags_391936: "Etiquetas de riesgo",
otherAssetCategory_c3e627: "Otra categoría de activos",
propertySystems_2983a3: "Sistemas del inmueble",
conditionFlags_0fd793: "Indicadores de estado",
transmission_ace17e: "Transmisión",
lastServiceDate_6a44ff: "Fecha del último servicio",
roadworthinessExpiry_a32510: "Caducidad de la aptitud para la circulación",
insuranceExpiry_5788c0: "Vencimiento del seguro",
capacityUnit_f595ba: "Unidad de capacidad",
useStructuredOptionSetsSoTemplateRecommendation_a4913e: "Utilice conjuntos de opciones estructurados para que la recomendación y generación de listas de control se mantengan limpias.",
addOneOrMoreRelationshipsNowOr_bdce2c: "Agregue una o más relaciones ahora o déjelo vacío para mantener este activo independiente.",
noDraftRelationshipsAddedYet_0698d2: "Aún no se han agregado borradores de relaciones.",
chooseTheRelatedAsset_35789f: "Elija el activo relacionado",
fromThisAsset_48c52c: "De este activo",
toThisAsset_f70126: "A este activo",
relationshipCriticality_1a33c6: "Criticidad de la relación",
riskPropagationMode_720d7e: "Modo de propagación del riesgo",
propagationMode_fa66d1: "Modo de propagación",
noAssetsToVisualizeYet_c42bdd: "Aún no hay activos que visualizar.",
links_014bcd: "Vínculos",
display_574ff9: "Visualización",
viewAffectedWork_acb250: "Ver trabajo afectado →",
relationshipTypes_558b4b: "Tipos de relación",
clickToEditOrRemove_8526e9: "Haga clic para editar o eliminar",
understandingRisk_2e43d7: "Comprender el riesgo",
whatRaisesOrLowersLikelihood_622b19: "Qué aumenta o disminuye la probabilidad",
whatRaisesOrLowersImpact_767cc7: "Qué aumenta o disminuye el impacto",
noRelationshipbasedAdjustmentsToShow_47ffe9: "No hay ajustes basados en relaciones para mostrar.",
likelihoodMixScoreWeightContribution_2582ca: "Combinación de probabilidad (puntuación × ponderación = contribución)",
impactMix_ec0686: "Combinación de impacto",
rawWeightedValues_f4522d: "Valores ponderados brutos",
assetRisk_54b50c: "Riesgo del activo",
"55Matrix_f6b01d": "Matriz 5×5",
topDrivers_f8f235: "Principales factores",
whyThisRiskScore_6c74da: "¿Por qué esta puntuación de riesgo?",
mo_e9e0ce: "/mes",
aW_073d87: "AW",
suggestedNextStep_4a96db: "Siguiente paso sugerido: ",
complianceAndAudit_d16087: "Cumplimiento y auditoría",
moreInBreakdown_3e1121: "y más en desglose",
opensMapsWithDirectionsFromYourLocation_44a789: "Abre los mapas con indicaciones desde tu ubicación",
closeDocument_7866c7: "Cerrar documento",
openingFile_c515cb: "Abriendo el archivo",
notDisplayingOpenItInYourBrowser_a5761f: "¿No se muestra? Ábrelo en tu navegador.",
openInBrowser_052269: "Abrir en el navegador",
noInappPreview_37df05: "Sin vista previa en la aplicación",
previewUnavailable_36d31d: "Vista previa no disponible",
thisDocumentCouldNotBeDisplayedHere_e78b36: "Este documento no se pudo mostrar aquí. Utilice \"Abrir en el navegador\" a continuación para leerlo.",
theDocumentRendererIsUnavailableInThis_3dc0a5: "El procesador de documentos no está disponible en esta compilación. Utilice \"Abrir en el navegador\" a continuación.",
loadingDocument_77cac7: "Cargando documento",
couldNotReadThisFile_fce43e: "No se pudo leer este archivo",
theFileCouldNotBeDownloadedUse_fd63bb: "No se pudo descargar el archivo. Utilice \"Abrir en el navegador\" a continuación o inténtelo nuevamente cuando tenga una conexión estable.",
loadingVideo_c18920: "Cargando vídeo",
workArrivesFromTheFieldAQR_d69f49: "El trabajo llega desde el campo, un escaneo QR o un solicitante, y luego pasa para revisarlo.",
howAssetWRXWorks_a6652b: "Cómo funciona AssetWRX",
theEverydayLoopEndToEndTap_f41cec: "El ciclo diario, de principio a fin. Toca cualquier etapa para ir a ella.",
howToGetTheMostOutOf_6ecde4: "Cómo aprovechar al máximo AssetWRX, por tarea, con tutoriales interactivos.",
loadingInspectionDetails_07441a: "Cargando detalles de inspección...",
weCouldntLoadThisInspection_0d9c6e: "No pudimos cargar esta inspección",
loadingChecklist_6d4b18: "Cargando lista de comprobación…",
inspectionDetails_f70991: "Detalles de la inspección",
thisInspectionWasCreatedFromARequest_62e54f: "Esta inspección se creó a partir de una solicitud y permanece vinculada a su cronograma de solicitud.",
openSourceRequest_847fb2: "Abrir la solicitud de origen",
clearSkip_6abff6: "Borrar salto",
clearsSkipSoYouCanAnswerThis_fdd91c: "Borra el salto para que puedas responder este elemento.",
useYesNoPassFailStarsOrSkipBelow_c5d2c7: "Utilice Sí/No, Pasa/No pasa, estrellas o Saltar debajo del título para responder.",
unskipItem_a158ab: "Deshacer el salto del elemento",
unskip_cde472: "Deshacer salto",
skipItem_cb392b: "Saltar elemento",
opensAShortFormYouCanSkip_8bc9f3: "Abre un formulario breve. Puedes saltar con o sin nota.",
notConfirmed_b9e09a: "No confirmado",
evidenceRecommendedAddAPhotoOfThe_f5d5bd: "Se recomienda evidencia: agregue una foto del problema.",
noVideosRecorded_803350: "No hay vídeos grabados",
upTo3Photos1VideoMax_382f91: "Hasta 3 fotos · 1 vídeo, máximo 20 segundos",
inspectionAttachments_4eccaa: "Adjuntos de la inspección",
skipTheCurrentGroupOfItemsBecause_22712a: "Omitir el grupo actual de elementos porque no se aplica ninguno",
skipThisGroup_348a6d: "Omitir este grupo",
keyboardShortcuts_266695: "Atajos de teclado",
closeKeyboardShortcuts_b87b09: "Cerrar atajos de teclado",
requestConversation_7db6bd: "Conversación de la solicitud",
retryExport_f58f53: "Reintentar exportación",
completedTheWork_099993: "Completó el trabajo.",
notSharedYetUseShareAboveTo_81bebb: "Aún no compartido: utilice Compartir arriba para enviar este informe a un contacto.",
couldNotGenerateReport_fb1286: "No se pudo generar el informe",
showAllDetails_c5a7a8: "Mostrar todos los detalles",
neededBeforeCompletion_304a39: "Necesario antes de finalizar",
completionProgress_e2e2b3: "Progreso de finalización",
latestUpdate_749cd8: "Última actualización",
noUpdatesYet_24f53d: "Aún no hay actualizaciones.",
beforeYouSubmit_ede7c3: "Antes de enviar:",
invoiceExtraction_b8d23c: "Extracción de facturas",
reviewExtractedItems_9649fe: "Revisar elementos extraídos",
noLineItemsDetectedTryAClearer_7ebd61: "No se detectaron líneas de pedido. Pruebe con una foto más clara o agregue elementos manualmente.",
removeLineItem_68fb55: "Eliminar línea de pedido",
useCalculated_7192f0: "Usar el valor calculado",
leaveBlankToRecordAs0Enter_74cafa: "Déjelo en blanco para registrarlo como 0. Ingrese el monto total para esta orden de trabajo.",
addLineItem_2932d8: "Agregar línea de pedido",
invoiceOrReceipt_bcd947: "Factura o recibo",
attached_8e632c: "Adjunto",
pDFImageOrWordDocument_812ab0: "PDF, imagen o documento de Word.",
whyThisJobWasSuggested_e32a41: "Por qué se sugirió esta orden de trabajo",
what3words_881ff5: "what3words",
filledcountsoap_1a66d3: "///filled.count.soap",
nothingToChooseFromYet_978c4e: "Aún no hay nada para elegir.",
reportNotAvailable_c048c4: "Informe no disponible",
thisLinkMayBeInvalidOrThe_0e72cd: "Es posible que este enlace no sea válido o que el informe ya no se comparta.",
itemsChecked_34daa1: "Elementos comprobados",
needAttention_46d04d: "Necesita atención",
seeTheFullReport_d02b8d: "Ver el informe completo",
signInToRequestAccess_2e7a0e: "Inicia sesión para solicitar acceso",
requestSentTheTeamManagingThisAsset_56c7e0: "Solicitud enviada. El equipo que administra este activo lo revisará; se le notificará cuando respondan.",
theTeamManagingThisAssetDeclinedThis_072c77: "El equipo que administra este activo rechazó esta solicitud. Comuníquese con ellos directamente si cree que debería tener acceso.",
yourRelationshipToThisAsset_088c6c: "Su relación con este activo",
selectARole_de9e0a: "Seleccione un rol",
anythingToAddOptional_d0e207: "¿Algo que añadir? (opcional)",
egImTheTenantAtThisProperty_900046: "por ej. Soy el inquilino de esta propiedad.",
staySignedIn_e5f5f7: "Mantener la sesión iniciada",
signatureCanvas_b150c4: "Lienzo de firma",
opensTheTimeSelector_03fd5a: "Abre el selector de hora.",
rowDensity_0a44a7: "Densidad de filas",
pullingTheLatestActivityForThisRequest_3eb3bd: "Extrayendo la última actividad para esta solicitud.",
selectARequest_e23d7c: "Seleccione una solicitud",
chooseARequestToSeeItsDetail_17587d: "Elige una solicitud para ver su detalle y actividad.",
caseTimeline_ea3757: "Cronología del caso",
addACheck_a948e9: "Agregar una comprobación",
cancelAddingACheck_a8ca4e: "Cancelar la adición de una comprobación",
searchChecklists_bf435d: "Buscar listas de verificación…",
buildANewChecklistToUseAs_eeb155: "Cree una nueva lista de verificación para usarla como verificación",
buildANewChecklist_4597c6: "Crear una nueva lista de verificación",
requireThisCheckBeforeTheJobCan_75004c: "Requerir esta verificación antes de que se pueda completar la orden de trabajo",
requiredToCompleteTheJob_93fe15: "Requerido para completar la orden de trabajo",
offByDefaultARequiredCheckBlocks_83f24c: "Desactivado de forma predeterminada. Una verificación obligatoria bloquea la finalización hasta que finaliza.",
sendACalendarInviteToSomeoneAt_1ef692: "Enviar una invitación de calendario a alguien en el activo",
optionalTheyllGetAnEmailCalendarInvite_f3c0fa: "Opcional: recibirán una invitación de calendario por correo electrónico (.ics) para este intervalo de tiempo.",
inviteToCalendar_f4347a: "Invitar al calendario",
thisCheckHasNoSteps_3d81af: "Esta comprobación no tiene pasos",
checkChangedTitle: "Otra persona actualizó esta comprobación",
checkChangedBody: "Ahora se muestran sus respuestas. Vuelve a responder donde lo necesites.",
theTemplateItCameFromIsEmpty_dee3b8: "La lista de control de la que procede está vacía. Edite la lista de control para agregar pasos y luego adjúntela nuevamente.",
savedOnThisDeviceWillSyncWhen_3db4e0: "Guardado en este dispositivo: se sincronizará cuando vuelva a estar en línea",
prepareWork_8aa4da: "Preparar el trabajo",
loadingWorkContext_c860da: "Cargando contexto de trabajo",
reopenCase_a32ef8: "Reabrir la solicitud",
reopen_61e05d: "Reabrir",
conversation_2a20c7: "Conversación",
writeAReply_dd081e: "Escribe una respuesta…",
escalated_aff666: "escalado",
closeWithoutAResponse_3bf706: "Cerrar sin respuesta",
closeWithoutResponse_6c6096: "Cerrar sin respuesta",
automateThisChase_49d451: "Automatiza este recordatorio",
couldntLoadYourTemplates_b41115: "No se pudieron cargar sus listas de control",
upcomingVisits_ecb005: "Próximas visitas",
theTeamHasPlannedWorkHereAnd_78e2ed: "El equipo ha planeado trabajar aquí y le pidió que confirme que alguien puede estar allí.",
whoWillLetUsIn_66de4a: "¿Quién nos dejará entrar?",
noOneNeeded_4ab28b: "No se necesita a nadie",
theyaposllBeAskedToConfirmTheVisit_d8cb82: "Se les pedirá que confirmen la hora de visita o sugieran otra diferente.",
sort_8b335a: "Ordenar:",
egReplaceWornBelt_49815f: "por ej. Reemplace la correa desgastada",
tryLoadingChecklistsAgain_bd84f3: "Intente cargar listas de verificación nuevamente",
noChecklistMatchesThisAssetTypeYet_d47d21: "Ninguna lista de verificación coincide todavía con este tipo de activo.",
createAChecklist_02f012: "Crear una lista de verificación",
createANewChecklistTemplate_ec189b: "Crear una nueva lista de control de lista de verificación",
newChecklist_d80825: "Nueva lista de verificación",
when_b2028c: "¿Cuándo?",
chooseWhenThisWorkShouldHappen_78b867: "Elija cuándo debe realizarse este trabajo",
later_56e2f5: "Más tarde",
howLongWillItTake_5c9649: "¿Cuánto tiempo llevará?",
suggestedTimes_aa2e2b: "Horarios sugeridos",
noSlotFitsBeforeTheDueDate_8c442c: "No hay espacio disponible antes de la fecha de entrega: el trabajo necesita más tiempo, otro responsable o una fecha límite cambiada.",
howToRunIt_5809c8: "Cómo ejecutarlo",
endsOptional_92d6de: "Termina (opcional)",
maxTimes_e58588: "Número máximo de veces",
advanceTheSeries_2f1cf7: "Avanza la serie",
skipARunIfThePreviousOne_1b5907: "Omitir el siguiente si el anterior sigue abierto",
remindMe_25df3f: "Recuérdame",
anythingTheInspectorShouldKnow_af9eeb: "Todo lo que el inspector debe saber",
assignTo_cc7907: "Asignar a",
theContractorYouAwardOrHandThis_9cbde2: "El contratista al que adjudicas o entregas esta orden de trabajo. Elegirlo aquí no lo asigna; lo hace la adjudicación.",
checks_5098dd: "Comprobaciones",
optionalAPrecheckConfirmsItIsSafe_db4e1f: "Opcional. Una comprobación previa confirma que es seguro empezar; una comprobación final confirma el trabajo antes de irse. Las comprobaciones añadidas aquí son obligatorias, por lo que la orden de trabajo no se puede completar hasta que estén terminadas.",
analysingOnDevice_54be55: "Analizando en el dispositivo…",
codes_199993: "Códigos",
meterReadings_a3c12c: "Lecturas del medidor",
dates_842b7b: "Fechas",
detected_74fb2c: "detectado",
extractedText_5ea632: "Texto extraído",
noInformationWasExtractedOnDevice_80b803: "No se extrajo información en el dispositivo.",
enhancingWithAI_8078cd: "Mejorando con IA…",
aIEnhancementWillBeAvailableWhenYoure_ff5c7e: "La mejora con IA estará disponible cuando vuelva a estar en línea. Todo lo leído en este dispositivo se guarda.",
summariseJourney_846b25: "Resumir recorrido",
loadedMatchesMoreAssetsAreAvailable_b38944: "{{value1}} coincidencias cargadas. Hay más activos disponibles.",
showing_6ec0cc: "Mostrando: {{value1}}",
organisations_b83a9b: "Organizaciones{{value1}}",
openJobs_31f2a1: "Órdenes de trabajo abiertas{{value1}}",
viewAll_f6220a: "Ver todo · {{value1}}",
latest_a94fea: "Última: {{value1}}",
previous_b3f133: "Anterior: {{value1}}",
risk_ad0435: "Riesgo: {{value1}} ({{value2}})",
health_c90470: "Salud: {{value1}} ({{value2}})",
compliance_49ba65: "Cumplimiento: {{value1}} ({{value2}})",
confidenceReviewBeforeApplying_a8e435: "{{value1}} confianza {{value2}}. Revisa antes de aplicar.",
confidenceReviewBeforeApplying_050de9: "{{value1}} {{value2}} % de confianza. Revisa antes de aplicar.",
itWillBeCreatedAsCommissionIt_d1903a: "Se creará como {{value1}}. Ponlo en servicio desde la página del activo cuando esté listo — una inspección y luego las órdenes de trabajo que genere.",
upToPhotosOptionalTapThePreview_750506: "Hasta {{value1}} fotos — opcional. Toca la vista previa o usa los botones de abajo.",
tapToAddAnother_f06704: "Toca para añadir otra ({{value1}}/{{value2}})",
upToPhotosTotal_59c8b8: "Hasta {{value1}} fotos en total",
headsUpAlreadyUsesThisIDSerial_108120: "Atención: «{{value1}}» ya usa este ID / número de serie.",
mo_8759d1: "{{value1}} meses",
upToPhotosOptionalSameAsWhen_a03894: "Hasta {{value1}} fotos (opcional). Igual que al crear un activo — toca la vista previa o usa Cámara / Galería para añadir más.",
addAnotherPhoto_634f18: "Añadir otra foto ({{value1}}/{{value2}})",
groups_104467: "Grupos: {{value1}}",
items_b74542: "Elementos: {{value1}}",
required_40bdfd: "Obligatorios: {{value1}}",
conditionalRules_047d88: "Reglas condicionales: {{value1}}",
currentVersionIsVSavingFromThis_07a9f2: "La versión actual es la v{{value1}}. Guardar desde este editor creará la v{{value2}}.",
categories_5b1690: "Categorías: {{value1}}",
depth_5fb610: "Profundidad: {{value1}}",
evidence_6674e1: "Evidencias: {{value1}}",
objectiveLengthChars_a7cb1d: "Longitud del objetivo: {{value1}} caracteres",
runID_27348d: "ID de ejecución: {{value1}}",
estimatedDurationMin_a210a3: "Duración estimada: {{value1}} min",
responseDeadline_834634: "Plazo de respuesta: {{value1}}",
targetStart_cb37f8: "Inicio previsto: {{value1}}",
targetEnd_f9f809: "Fin previsto: {{value1}}",
estimatedBudget_070f47: "Presupuesto estimado: {{value1}} {{value2}}",
attachedPhotos_740082: "Fotos adjuntas · {{value1}}",
category_5e6549: "Categoría: {{value1}}",
urgency_3bf5ac: "Urgencia: {{value1}}",
dueDate_279007: "Fecha de vencimiento: {{value1}}",
type_45c583: "Tipo: {{value1}}",
pleaseRespondBy_ec61f2: "Por favor, responde antes del {{value1}}",
playVideo_dbbc47: "Reproducir vídeo {{value1}}",
yourReason_882f62: "Tu motivo: «{{value1}}»",
twofactorOfEnrolled_3402d7: "Verificación en dos pasos: {{value1}} de {{value2}} activados",
currencyCommunication_43aa12: "Moneda: {{value1}} · Comunicación: {{value2}}",
errorsInView_5612eb: "Errores en la vista: {{value1}}",
when_f062b4: "Cuándo: {{value1}}",
locale_469d05: "Idioma: {{value1}}",
credits_ae86ee: "Créditos: {{value1}} ({{value2}})",
entity_1fba91: "Entidad: {{value1}}",
step_0d893e: "Paso {{value1}}",
lastSuccessfulSyncLastFailedSyncNone_8b8bea: "Última sincronización correcta: {{value1}} · Última sincronización fallida: ninguna registrada",
credentialSecretHiddenAfterCreationRotatedRevoked_326665: "Credencial: secreto oculto tras la creación · rotado {{value1}} · revocado {{value2}}",
status_ac4b0a: "Estado: {{value1}}",
lastSuccessfulSync_d6b22a: "Última sincronización correcta: {{value1}}",
lastFailedSync_e7a87b: "Última sincronización fallida: {{value1}}",
logsHistory_117ea0: "Registros / historial: {{value1}}",
suggested_bfc937: "Sugerido: {{value1}} · {{value2}} %",
row_69394c: "Fila {{value1}}",
updated_3ada36: "Actualizados: {{value1}}",
newSitesCreated_a610d0: "Sitios nuevos creados: {{value1}}",
skippedByConflictPolicy_e92870: "Omitidos por la política de conflictos: {{value1}}",
failed_1c734b: "Fallidos: {{value1}}",
pOST_39bb77: "POST {{value1}}",
credentialTokenRotated_3254bf: "Credencial: token {{value1}} {{value2}}...{{value3}} · rotado {{value4}}",
invocations_1e09a7: "{{value1}} invocaciones",
lastSuccess_204f28: "Último éxito: {{value1}}",
lastFailure_fe19b0: "Último fallo: {{value1}}",
authTypeHeader_b1a0ff: "Tipo de autenticación: {{value1}}. Cabecera: {{value2}}.",
secretState_e4463d: "Estado del secreto: {{value1}}.",
request_65ee72: "Solicitud: {{value1}}",
response_7fff2f: "Respuesta: {{value1}}",
statusRecentAssistantInvocations_a6c770: "Estado: {{value1}} • invocaciones recientes del asistente: {{value2}}",
lastInvocation_8b8558: "Última invocación: {{value1}}",
lastError_e74e5f: "Último error: {{value1}}",
aHostedMCPEndpointForThisWorkspace_2ee242: "Un punto de conexión MCP alojado para este espacio de trabajo: {{value1}}",
toolsAndResourcesEachFilteredByWorkspace_bdcaa8: "{{value1}} herramientas y {{value2}} recursos, cada uno filtrado por espacio de trabajo y por los ámbitos de la cuenta de servicio.",
reads_a89270: "Lecturas: {{value1}}",
writes_532f15: "Escrituras: {{value1}}",
path_676484: "Ruta: {{value1}}",
scopes_993717: "Ámbitos: {{value1}} {{value2}}",
expiresCreated_8b46c7: "Caduca {{value1}} • creado {{value2}}",
preview_36c78a: "Vista previa: {{value1}}",
ms_588b6b: "{{value1}} ms • {{value2}}",
credits_05f92c: "{{value1}} créditos",
checks_05efc2: "{{value1}}{{value2}} % · {{value3}} comprobaciones",
dataQuality_984221: "{{value1}} · {{value2}} % de calidad de datos",
reason_74bb8e: "Motivo: {{value1}}",
showingRequestsFrom_dc8278: "Mostrando solicitudes desde {{value1}}.",
typeToConfirm_fac0ca: "Escribe {{value1}} para confirmar",
lastCycles_9f5334: "Últimos {{value1}} ciclos",
openWork_cc107a: "Trabajo abierto · {{value1}}",
tags_6e1f36: "Etiquetas: {{value1}}",
team_fff0a5: "Equipo: {{value1}}",
compliance_89f882: "Cumplimiento · {{value1}}",
registered_8b441e: "Registrado {{value1}}",
ofCoreFieldsFilled_0f25e0: "{{value1}} de {{value2}} campos principales rellenados",
stillMissing_f3dd5e: "Aún falta: {{value1}}",
appliedReviewTheFieldsBelowTheySave_866743: "{{value1}} {{value2}} aplicado(s) — revisa los campos de abajo; se guardan automáticamente.",
poor_904815: "{{value1}} deficiente",
watch_a1d644: "{{value1}} en observación",
good_aaf5c2: "{{value1}} bueno",
unscored_e4e509: "{{value1}} sin puntuar",
criticality_b7cd47: "Criticidad {{value1}} · {{value2}}",
open_a1601a: "{{value1}} {{value2}} abiertos",
lastInspected_71de34: "Última inspección · {{value1}}",
rulesCalculated_3cece2: "Reglas {{value1}} · Calculado {{value2}}",
likelihoodImpact_b6a9fb: "Probabilidad {{value1}} × Impacto {{value2}}",
"5Weight_d64551": "{{value1}}/5 · {{value2}} · {{value3}} % de peso",
standaloneScoresBeforeLinkAdjustmentLI_1c934f: "Puntuaciones individuales antes del ajuste por vínculos: P {{value1}} · I {{value2}}",
relationshipAdjustmentsAppliedLI_17818d: "Ajustes por relaciones aplicados: P {{value1}}{{value2}} · I {{value3}}{{value4}}",
lRawRoundedIRawRounded_c4c6f6: "P bruta {{value1}} → redondeada {{value2}}; I bruto {{value3}} → redondeado {{value4}}",
rules_4b3591: "Reglas {{value1}}{{value2}}",
skipped_2fd804: "Omitido{{value1}}",
reportRef_4ee599: "Ref. del informe: {{value1}}",
completed_57e944: "Completado {{value1}}",
round_6178c9: "Ronda {{value1}} · {{value2}}",
firstShared_249645: "Compartido por primera vez {{value1}}{{value2}}",
dueBy_d51c85: "Vence el {{value1}}",
scheduledFor_37e8f3: "Programado para el {{value1}}",
confidence_615dda: "Confianza: {{value1}}",
useExtractedTotalAsActualCost_463a4f: "Usar el total extraído{{value1}}{{value2}} como coste real",
fromQtyUnit_c1c1c3: "De cant. × unidad: {{value1}}{{value2}}{{value3}}",
estimate_3a8133: "Estimación: {{value1}}",
actual_e5762d: "Real: {{value1}}",
vsEstimate_5939a7: "vs. estimación: {{value1}}{{value2}}{{value3}} ({{value4}}{{value5}} %)",
materialsSubtotal_f5bcb3: "Subtotal de materiales: {{value1}}{{value2}}",
inspected_517599: "Inspeccionado {{value1}}",
theFullReportFindingsPhotosRecommendationsAnd_e1e094: "El informe completo — hallazgos, fotos, recomendaciones y posibles costes — solo se comparte con personas aprobadas. {{value1}}",
selected_deace8: "{{value1}} seleccionados",
signedBy_06a094: "Firmado por {{value1}}",
tapSummariseJourneyToTryAgain_f327c1: "{{value1}} Toca «Resumir recorrido» para volver a intentarlo.",
},
close: "Cerrar",
back: "Atrás",
next: "Siguiente",
detailTabs: {
  scrollForward: "Mostrar más pestañas",
  scrollBack: "Mostrar pestañas anteriores",
},
freePeriod: {
  until: "Gratis hasta el {{date}}. Elige un plan para que tu espacio de trabajo siga funcionando después.",
  ended: "Tu periodo gratuito ha terminado y tu espacio de trabajo es de solo lectura. Elige un plan para seguir trabajando. No se ha eliminado nada.",
},
aiReport: {
  link: "Denunciar",
  title: "Denunciar esta respuesta de IA",
  body: "Dinos qué tiene de malo. Guardamos el texto que viste para poder revisarlo.",
  offensive: "Ofensiva",
  harmful: "Dañina o peligrosa",
  wrong: "Incorrecta o engañosa",
  cancel: "Cancelar",
  sentTitle: "Denuncia enviada",
  sentBody: "Gracias. Revisamos todas las denuncias.",
  failedTitle: "No se pudo enviar la denuncia",
},
collaboratorUpgrade: {
contractorTitle: "Gestiona tus propios trabajos y clientes",
contractorBody: "Lleva aquí tus propios clientes, trabajos y facturas, con tus propios créditos de IA. El trabajo que haces para otros sigue igual.",
requesterTitle: "Lleva tu propio registro de mantenimiento",
requesterBody: "Controla los inmuebles y equipos que cuidas tú mismo, con sus trabajos, inspecciones y documentos. Lo que se comparte contigo sigue igual.",
recipientTitle: "Inspecciona tus propios activos así",
recipientBody: "Haz inspecciones e informes como este en tus propios activos. Lo que se comparte contigo sigue igual.",
otherTitle: "Gestiona tus propios activos",
otherBody: "Crea tu propio espacio de trabajo para tus activos y tu trabajo. Lo que haces para otros sigue igual.",
cta: "Ver planes",
freeReady: "Tu espacio de trabajo está listo. Añade tu primer activo con el botón +.",
},
aiCost: {
included: "Incluido por {{host}} · quedan {{n}} créditos este mes",
includedUsed: "{{host}} ya no incluye más IA este mes. Puedes usar tus propios créditos.",
  generateFailed: "No se pudo redactar el borrador. Inténtelo de nuevo o cree la lista usted.",
  buy: "Comprar créditos",
  onWeb: "Los créditos se compran en AssetWRX desde la web, o llegan con sus créditos mensuales.",
  buyHint: "Compre un paquete de créditos para continuar, o espere a sus créditos mensuales.",
  askAdmin: "Pida al propietario o a un administrador del espacio que compre créditos, o espere a sus créditos mensuales.",
  askNamed: "Pida a {{name}} que compre créditos, o espere a sus créditos mensuales.",
  shortUnknown: "No quedan suficientes créditos de IA para esto.",
  short: "Créditos insuficientes: hacen falta {{n}}, quedan {{balance}}.",
  hint: "Créditos de IA usados: {{n}} · Disponibles: {{balance}}",
},
aiGenerate: {
  discard: "Descartar",
  keep: "Conservarlo",
  discardBody: "No se guardará. Puede redactar otro desde el formulario.",
  discardTitle: "¿Descartar este borrador?",
  saveDraft: "Guardar borrador",
  unsavedMessage: "Tu borrador de lista de control con IA aún no se ha guardado. ¿Salir y perderlo?",
  leaveReviewTitle: "¿Salir de la revisión?",
  savedTitle: "Lista de control guardada",
  feedbackFailedBody: "No se pudieron registrar los comentarios. La lista de control se guardó correctamente.",
  goToTemplate: "Ir a la lista de control",
  saveFailed: "No se pudo guardar la lista de control.",
  leaveReviewBody: "Tu borrador no se guardará. Descártalo desde la pantalla de revisión para dejar comentarios.",
  stay: "Quedarse",
  moreOptionsSummary: "Tiempo, fotos, orden y estilo",
  moreOptions: "Más opciones",
  baseLabel: "Copiar el estilo de (opcional)",
  goal: {
    fail_only_evidence: "Fotos solo si algo falla",
    physical_flow: "El orden del recorrido",
    compliance: "Cumplir las normas",
  },
  goalLabel: "Organizarla también para (opcional)",
  evidence: {
    always: "En cada punto",
    optional: "Cuando el inspector quiera",
    fail_only: "Solo cuando algo falla",
  },
  evidenceLabel: "Cuándo pedir fotos",
  depth: {
    detailed: "Exhaustivo",
    standard: "Estándar",
    lite: "Revisión rápida",
  },
  depthLabel: "Nivel de detalle",
  noAsset: "Ningún activo concreto",
  basePlaceholder: "Elija una lista de control de lista para copiar su estilo",
  baseSelected: "Seleccionada",
  baseNone: "Ninguna",
},
aiDisclosure: {
title: "Las funciones de IA usan Google",
body: "AssetWRX envía las fotos y el texto implicados a Google (Gemini) para hacerlo. Google no entrena con ellos. Las fotos de evidencia que conserves de Vision pueden mejorar WRX Vision, salvo que el propietario del espacio lo desactive. Detalles en Perfil → Privacidad y datos.",
allow: "Permitir",
notNow: "Ahora no",
declined: "No se usó la IA. Puede permitirla la próxima vez que use una función de IA.",
},
sessionExpiryBanner: {
expiresIn_one: "Su sesión caducará en {{count}} minuto.",
expiresIn_many: "Su sesión caducará en {{count}} de minutos.",
expiresIn_other: "Su sesión caducará en {{count}} minutos.",
},
offlineStrip: {
offline: "Sin conexión · se sincroniza al reconectar",
offlineQueued_one: "Sin conexión · {{count}} cambio pendiente",
offlineQueued_many: "Sin conexión · {{count}} cambios pendientes",
offlineQueued_other: "Sin conexión · {{count}} cambios pendientes",
syncing_one: "Sincronizando {{count}} cambio…",
syncing_many: "Sincronizando {{count}} cambios…",
syncing_other: "Sincronizando {{count}} cambios…",
queued_one: "{{count}} cambio pendiente de sincronizar",
queued_many: "{{count}} cambios pendientes de sincronizar",
queued_other: "{{count}} cambios pendientes de sincronizar",
},
photoLimit: {
title: "Límite de fotos alcanzado",
body_one: "Puede adjuntar hasta {{count}} foto aquí. Quite una para añadir otra.",
body_many: "Puede adjuntar hasta {{count}} de fotos aquí. Quite una para añadir otra.",
body_other: "Puede adjuntar hasta {{count}} fotos aquí. Quite una para añadir otra.",
},
mapBoundary: {
start: "Toque las esquinas de este sitio",
more_one: "Toque al menos {{count}} esquina más",
more_many: "Toque al menos {{count}} de esquinas más",
more_other: "Toque al menos {{count}} esquinas más",
adjust: "Arrastre una esquina para ajustarla, o guarde",
},
importSites: {
listSeparator: ", ",
moreNames_one: ", +{{count}} más",
moreNames_many: ", +{{count}} más",
moreNames_other: ", +{{count}} más",
confirmTitle_one: "¿Crear hasta {{count}} sitio nuevo?",
confirmTitle_many: "¿Crear hasta {{count}} de sitios nuevos?",
confirmTitle_other: "¿Crear hasta {{count}} sitios nuevos?",
confirmBody_one: "Esta importación creará hasta {{count}} sitio nuevo y le vinculará activos:\n{{names}}{{more}}\n\nLos sitios existentes se reutilizan cuando el nombre coincide. Si alguno de ellos es un duplicado o una errata, vuelva atrás y corrija primero la hoja.",
confirmBody_many: "Esta importación creará hasta {{count}} de sitios nuevos y les vinculará activos:\n{{names}}{{more}}\n\nLos sitios existentes se reutilizan cuando el nombre coincide. Si alguno de ellos es un duplicado o una errata, vuelva atrás y corrija primero la hoja.",
confirmBody_other: "Esta importación creará hasta {{count}} sitios nuevos y les vinculará activos:\n{{names}}{{more}}\n\nLos sitios existentes se reutilizan cuando el nombre coincide. Si alguno de ellos es un duplicado o una errata, vuelva atrás y corrija primero la hoja.",
backToPreview: "Volver a la vista previa",
createAndImport: "Crear e importar",
actionCreate: "crear",
actionUpdate: "actualizar",
actionSkip: "omitir",
actionError: "error",
calloutNew_one: "Se creará hasta {{count}} sitio nuevo",
calloutNew_many: "Se crearán hasta {{count}} de sitios nuevos",
calloutNew_other: "Se crearán hasta {{count}} sitios nuevos",
calloutMatched: "Sitios que coinciden por nombre",
linkExisting_one: "Los activos se vinculan a {{count}} sitio existente que coincide por nombre.",
linkExisting_many: "Los activos se vinculan a {{count}} de sitios existentes que coinciden por nombre.",
linkExisting_other: "Los activos se vinculan a {{count}} sitios existentes que coinciden por nombre.",
matchedCaseInsensitive: "Los nombres se comparan con los sitios existentes (sin distinguir mayúsculas y minúsculas).",
reuseNote: " Los sitios existentes se reutilizan cuando el nombre coincide — usted confirma los sitios nuevos antes de importar.",
},
attachmentsPanel: {
title: "Adjuntos",
all: "Todos",
empty: "Todavía no hay nada adjunto.",
kind: { photo: "Fotos", video: "Vídeos", audio: "Voz", document: "Archivos" },
source: {
fallback: "Adjunto",
"job.completion_photo": "Foto de finalización",
"job.completion_video": "Vídeo de finalización",
"job.completion_voice_note": "Nota de voz de finalización",
"job.receipt": "Recibo",
"job.activity_attachment": "Adjunto de la actividad",
"inspection.item_photo": "Foto de inspección",
"inspection.item_video": "Vídeo de inspección",
"inspection.item_voice_note": "Nota de voz de inspección",
},
},
};
